import {colorGrid} from 's2s-themes';

//console.log('>>>>> cg', colorGrid);
// How to add themed styles
// 1 - For each theme (light, dark, etc.) add a new object for your components
//     NOTE:  the object key must be the component name in lowercase!!
// 2 - Within the object with the key of your component, add the styles in the
//     same structure as they are defined in your component default styles.
//     You can copy and paste from your component to make sure you are accurate
// 3 - Update the style values that are relevant to the theme, and remove style
//     attributes that are not changing based on the theme.
// 4 - Repeat step 3 for each theme.

const themes = {
  // ******************************
  // ****        Light         ****
  // ******************************
  Light: {
    /******** ALERT ITEM *********/
    alertitem : {
      alertItemStyles : {

      },
      detailTextStyle:{
        color: colorGrid.gray0
      },
      errorBorderStyles : {
        //border: '4px solid ' + colorGrid.red9
      },
      warnBorderStyles : {
        border: '4px solid ' + colorGrid.orange9
      },
      infoBorderStyles : {
        border: '4px solid ' + colorGrid.green9
      },
      errorDetailStyle:{
        backgroundColor: colorGrid.red9
      },
      warnDetailStyle:{
        backgroundColor: colorGrid.orange9
      },
      infoDetailStyle:{
        backgroundColor: colorGrid.green9
      },
      errorBackgroundStyles : {
        backgroundColor: colorGrid.red8
      },
      warnBackgroundStyles : {
        backgroundColor: colorGrid.orange8
      },
      infoBackgroundStyles : {
        backgroundColor: colorGrid.green8
      },
      headingStyles: {
        //color: colorGrid.gray0
      },
      alertSvgStyles : {
        fill: colorGrid.gray0
      },
      closeSvgStyles : {
        //fill: '#8c0112'
      },
      alertDetailStyle : {
        backgroundColor: colorGrid.gray0
      },
      errorCloseSvgStyles : {
        fill: colorGrid.red2
      },

      warnCloseSvgStyles : {
        fill: colorGrid.orange2
      },

      infoCloseSvgStyles : {
        fill: colorGrid.green2
      }
    },

    /********* ALERT LOG *********/
    alertlog : {
      headerArea : {
        backgroundColor: colorGrid.gray0
        // boxShadow: 'inset 0px 1px 0px 0px, inset 0px -1px 0px 0px' + colorGrid.gray3
      },
      headerText:{
        color: colorGrid.gray9
      },
      clearAlerts: {
        buttonStyles: {
          backgroundColor: colorGrid.gray0
        },
        labelStyles:{
          color: colorGrid.gray9
        }
      },
      backIconArea: {
        buttonStyles: {
          backgroundColor: colorGrid.gray0
        },
        labelStyles:{
          color: colorGrid.gray9
        }
      },
      listArea : {
        backgroundColor: colorGrid.gray1
      },
      dateSeparator : {
          // boxShadow: 'inset 0px 1px 0px 0px, inset 0px -1px 0px 0px' + colorGrid.gray3,
          color: colorGrid.gray7,
          backgroundColor: colorGrid.gray1
      },
      noAlerts : {
        boxShadow: 'inset 0 1px 0 0' + colorGrid.gray3
      },
      noAlertText: {
        color: colorGrid.gray9
      },
      noAlertIcon:{
        fill: colorGrid.gray7
      }
    },

    /******* CALL CONTROLS *******/
    callcontrols : {
      callControlsWrapStyles: {
        backgroundColor: colorGrid.gray0
      },
      hoverStyle: {
        hoverButtonStyles: {
          backgroundColor: colorGrid.gray2
          //border: '2px solid',
          //borderColor: colorGrid.gray5
        },
        hoverLabelStyles: {
          //color: colorGrid.gray0
        },
        hoverSvgStyles: {
          //fill: colorGrid.gray0
        }
      },
      focusStyle: {
        focusButtonStyles: {
          backgroundColor: colorGrid.gray0
          //border: '2px solid #efefef'
        },
        focusLabelStyles: {
          color: colorGrid.gray9
        },
        focusSvgStyles: {
          fill: colorGrid.gray9
        }
      },
      // area that contains top two button bars
      topContainer: {
        background: colorGrid.gray0
      },
      audioControlBtn: {
        buttonStyles: {
          border: '2px solid transparent',
          backgroundColor: colorGrid.gray0
        },
        labelStyles: {
          fill: colorGrid.gray9
        },
        svgStyles: {
          fill: colorGrid.gray9
        }
      },
      holdButton: {
        buttonStyles: {
          border: '2px solid transparent',
          backgroundColor: colorGrid.gray0
        },
        labelStyles: {
          fill: colorGrid.gray9
        },
        svgStyles: {
          fill: colorGrid.gray9
        }
      },
      isMutedHeldButtons: {
        buttonStyles: {
          //border: 'solid 2px',
          //borderColor: colorGrid.red8,
          //backgroundColor: colorGrid.gray9
        },
        labelStyles: {
          //color: colorGrid.gray0
        },
        svgStyles: {
          //fill: colorGrid.gray0
        }
      },
      genericButton: {
        buttonStyles: {
          border: '2px solid transparent',
          backgroundColor: colorGrid.gray0
        },
        svgStyles: {
          fill: colorGrid.gray9
        }
      },
      // area that contains bottom buttonbar
      bottomContainer: {
      },
      hangupButton: {
        buttonStyles: {
          backgroundColor: colorGrid.red8,
          border: 'none',
          borderRadius: '2px'
        },
        labelStyles: {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.red6
        }
      },
      transferButton: {
        buttonStyles : {
          backgroundColor: colorGrid.green8,
          borderRadius: '2px'
        },
        labelStyles : {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.green6
        }
      },
      disabledByAttendedTransfer: {
        buttonStyles: {
          border: '2px solid transparent',
          backgroundColor: colorGrid.gray0
        },
        labelStyles: {
          fill: colorGrid.gray9
        },
        svgStyles: {
          fill: colorGrid.gray9
        }
      },
      audioControlCompStyles : {
        audioControlComponent: {
          backgroundColor: colorGrid.gray0
        },
        audioSettingArea: {
          borderTop: '0px',
          borderRight: '0px',
          borderBottom: '1px solid',
          borderLeft: '0px',
          borderColor: colorGrid.gray3
        },
        buttonBarArea: {},
        controls: {},
        heading: {},
        section: {},
        selection: {},
        slider: { },
        buttonBarCompStyle: {
          buttonBar: {
            backgroundColor: colorGrid.gray0
          }
        },
        saveBtnCompStyle: {
          buttonStyles : {
            backgroundColor: colorGrid.green8,
            borderTopLeftRadius: '2px',
            borderTopRightRadius: '2px',
            borderBottomLeftRadius: '2px',
            borderBottomRightRadius: '2px'
          },
          labelStyles : {
            color: colorGrid.gray0
          },
          hoverButtonStyles: {
            backgroundColor: colorGrid.green6
          }
        },
        cancelBtnCompStyle: {
          buttonStyles : {
            backgroundColor: colorGrid.gray0,
            borderTop: '1px solid',
            borderRight: '1px solid',
            borderBottom: '1px solid',
            borderLeft: '1px solid',
            borderColor: colorGrid.gray3
          },
          labelStyles : {
            color: colorGrid.gray9
          },
          hoverButtonStyles : {
            backgroundColor: colorGrid.gray2
          }
        }
      }
    },

    /******* CALL DETAIL *********/
    calldetail : {
      selectedCallDetailItem:{
        backgroundColor: colorGrid.gray8,
        color: colorGrid.gray0
      },
      unselectedCallDetailItem:{
        backgroundColor: colorGrid.gray4,
        boxShadow: 'inset 0px -1px 0px 0px, inset 0px 1px 0px 0px' + colorGrid.gray7,
        color: colorGrid.gray9
      },
      selectedSVG: {
        fill: colorGrid.gray0
      },
      unselectedSVG: {
        fill: colorGrid.gray9
      },
      statusCompStyle: {
        statusSvgStyle:{
          //fill: '#fff'
        }
      }
    },

    /******* CALL HISTORY ********/
    callhistory : {
      alertSvg:{
        fill: colorGrid.gray7
      },
      callHistoryContainer:{
        backgroundColor: colorGrid.gray1
      },
      header: {
        backgroundColor: colorGrid.gray0
      },
      noHistoryMsg:{
        color: colorGrid.gray9
      },
      noCallHistory: {
        backgroundColor: colorGrid.gray1
      },
      dateHeading: {
        background: colorGrid.gray1
      },
      backBtn: {
        buttonStyles: {
        },
        labelStyles: {
          color: colorGrid.gray9
        },
        svgStyles: {
          color: colorGrid.gray9
        }
      },
      clearBtn: {
        buttonStyles: {

        },
        labelStyles: {
          color: colorGrid.gray9
        },
        svgStyles: {
          fill: colorGrid.gray9
        }
      },
      callDetailComp:{
        unselectedCallDetailItem:{
          backgroundColor: colorGrid.gray0
        },
        callDirectionSVG: {
          fill: colorGrid.gray7
        },
        timerMute:{
          color: colorGrid.gray7
        },
        statusArea: {
          color: colorGrid.gray7
        },
        infoArea: {
          color: colorGrid.gray7
        }
      }
    },

    /******** CALL LIST **********/
    calllist : {
      callDetailList: {},
      callList: {},
      callListContainer: {
        backgroundColor: colorGrid.gray4,
        color: colorGrid.gray9,
        boxShadow: 'inset 0px 1px 0px 0px' + colorGrid.gray7
      },
      defaultMsg: {},
      divider: {},
      listItem: {},
      listHeader: {},
      svg: {},
      transferDetailComp: {
        selectedCallDetailItem:{
          backgroundColor: '#326184'
        },
        unselectedCallDetailItem:{
          backgroundColor: '#4c7593'
        }
      },
      callDetailComp: {
        unselectedCallDetailItem:{
          backgroundColor:  colorGrid.gray4,
          color: colorGrid.gray9,
          fill: colorGrid.gray9
        },
        selectedCallDetailItem:{
          backgroundColor: colorGrid.gray8,
          color: colorGrid.gray0,
          fill: colorGrid.gray2
        },
        timerMute: {},
        callDirectionSVG: {},
        statusArea: {},
        infoArea: {},
        callerId: {},
        callerIdName:{},
        callerExt:{},
        callStatus: {},
        svgArea: {},
        statusCompStyle: {
          statusSvgStyle:{},
          statusConnectedSvgStyle: {},
          statusStyle: {},
          messageStyle:{}
        }
      }
    },

    /******* DIALING INPUT *******/
    dialinginput : {
      dialingInputFocused : {
         backgroundColor: colorGrid.gray3,
         color: colorGrid.gray9
      },
      dialingInputUnfocused : {
        backgroundColor: colorGrid.gray3,
        boxShadow: 'inset 0px -1px 0px 0px, inset 0px 1px 0px 0px' + colorGrid.gray5
        // color: colorGrid.gray9
      },
      inputFocused : {
        backgroundColor: colorGrid.gray3
      },
      inputUnfocused : {
        backgroundColor: colorGrid.gray3
      },
      placeholderColor : {
        color: colorGrid.gray7
      },
      backspace: {}
    },

    /****** INCOMING CALL ********/
    incomingcall : {
      acceptComp:{
          buttonStyles : {
            border: 'none',
            backgroundColor: colorGrid.green8,
            borderTopLeftRadius: '2px',
            borderTopRightRadius: '2px',
            borderBottomLeftRadius: '2px',
            borderBottomRightRadius: '2px'
          },
          labelStyles : {
            color: colorGrid.gray0
          },
          hoverButtonStyles: {
            backgroundColor: colorGrid.green6
          }
        },
      callDetailComp: {
        unselectedCallDetailItem:{
          backgroundColor: colorGrid.gray1,
          color: colorGrid.gray9
        }
      },
      declineComp: {
        buttonStyles : {
          border: 'none',
          backgroundColor: colorGrid.red8,
          borderTopLeftRadius: '2px',
          borderTopRightRadius: '2px',
          borderBottomLeftRadius: '2px',
          borderBottomRightRadius: '2px'
        },
        labelStyles : {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.red6
        }
      },
      header: {
        backgroundColor: colorGrid.gray0,
        color: colorGrid.gray9
      },
      incomingCallContainer:{
        backgroundColor: colorGrid.gray0
      },
      voicemailComp: {
        buttonStyles : {
          backgroundColor: colorGrid.gray0,
          borderTop: '1px solid',
          borderRight: '1px solid',
          borderBottom: '1px solid',
          borderLeft: '1px solid',
          borderColor: colorGrid.gray3
        },
        labelStyles : {
          color: colorGrid.gray9
        },
        hoverButtonStyles : {
          backgroundColor: colorGrid.gray2
        }
      }
    },

    /********** KEYPAD ***********/
    keypad : {
      wrapper: {
        backgroundColor: colorGrid.gray0
      },
      KeyItemContainer : {
        backgroundColor: colorGrid.gray0
      },
      keypadItem: {
        container: {
          backgroundColor: colorGrid.gray0,
          borderTop: '1px solid transparent',
          borderRight: '1px solid transparent',
          borderBottom: '1px solid transparent',
          borderLeft: '1px solid transparent',
          color: colorGrid.gray9,
          ':hover': {
            // color: colorGrid.gray9,
            backgroundColor: colorGrid.gray2,
            borderTop: '1px solid',
            borderRight: '1px solid',
            borderBottom: '1px solid',
            borderLeft: '1px solid',
            borderColor: colorGrid.gray5
          },
          ':active': {
            color: colorGrid.blue6,
            backgroundColor: colorGrid.gray0,
            borderTop: '1px solid',
            borderRight: '1px solid',
            borderBottom: '1px solid',
            borderLeft: '1px solid',
            borderColor: colorGrid.blue6
          }
        },
        textArea : {
          color: colorGrid.gray9
        },
        keyValue: {
          color: colorGrid.gray9
          // fontSize: '16px'
        },
        keyString: {
          color: colorGrid.gray6
          // fontSize: '12px',
        }
      }
    },

    /********** LOGIN ************/
    login : {
      //styles forgot password block
      forgot : {
        loginBlockForgot : {
          backgroundColor: colorGrid.gray1
        },
        textAreaStyle: {
          color: colorGrid.gray9
        },
      //styles input field
        labelledInputForgotStyle : {
          inputField: {
            color: colorGrid.gray9
          },
          showHide: {}
        },
       //styles button area
        buttonAreaForgot: {},
      //styles cancel button
        cancelButtonStyle : {
          buttonStyles: {
            backgroundColor: colorGrid.gray0,
            border: 'solid 1px' + colorGrid.gray3
          },
          labelStyles: {
            color: colorGrid.gray9
          },
          hoverButtonStyles: {
            backgroundColor: colorGrid.gray2,
            border: 'solid 1px' + colorGrid.gray5
          },
          focusButtonStyles: {
            backgroundColor: colorGrid.gray2
          }
        },
         //styles reset password button
        resetButtonStyle : {
          buttonStyles: {
            backgroundColor: colorGrid.green8
          },
          labelStyles: {
            color: colorGrid.gray0
          },
          hoverButtonStyles: {
            backgroundColor: colorGrid.green6
          },
          focusButtonStyles: {
            backgroundColor: colorGrid.green6
          }
        }
      }, //end forgot password block
      login: {},
      loginForm: {
        loginBlockStyle: {
          backgroundColor: colorGrid.gray1
        },
        //styles top labelled input field
        labelledInputEmailStyle : {
          labelledInputComponentStyle: {},
          inputField : {},
          inputFieldWithHover: {}
        },
        //styles password input field
        labelledInputPasswordStyle : {
          inputField: {},
          inputFieldWithHover:{},
          showHide: {
            color: colorGrid.gray9
          }
        },
        // area that contains checkbox and forgot password
        linkWrapper: {},
         //styles checkbox/link area
        checkboxForgotPWAreaStyle: {},
        //styles the checkbox
        checkboxStyle: {
          checkbox: {
            backgroundColor: colorGrid.gray0
          },
          checkboxChecked: {
            backgroundColor: colorGrid.blue6
          },
          label: {
            color: colorGrid.gray9
          }
        },
        //styles forgot password button
        forgotButtonBottomStyle: {
          color: colorGrid.blue6
        },
         //styles forgot password button
        forgotButtonRightStyle: {
          color: colorGrid.blue6
        },
        //styles button area
        buttonArea : {},
        //styles sign in button
        buttonStyle : {
          buttonStyles: {
            backgroundColor: colorGrid.green8
          },
          labelStyles: {
            color: colorGrid.gray0
          },
          hoverButtonStyles: {
            backgroundColor: colorGrid.green6
          },
          focusButtonStyles: {
            backgroundColor: colorGrid.green6
          }
        }
      }, //end login block

      reset : { //styles reset block
        loginBlockReset: {
          backgroundColor: colorGrid.gray1
        },
        textAreaResetStyle: {
          color: colorGrid.gray9
        },
        //styles top password input field
        inputPasswordResetStyle : {
          inputField: {
            color: colorGrid.gray9
          },
          showHide: {
            color: colorGrid.gray9
          }
        },
        inputBottomPasswordStyle : {
          labelledInputComponentStyle: {},
          inputField : {
            color: colorGrid.gray9
          },
          showHide: {
            color: colorGrid.gray9
          }
        },
         //styles button area
        buttonAreaReset: {},
         //styles cancel button
        notNowButtonStyle : {
          buttonStyles: {
            backgroundColor: colorGrid.gray0,
            border: 'solid 1px' + colorGrid.gray3
          },
          labelStyles: {
            color: colorGrid.gray9
          },
          hoverButtonStyles: {
            backgroundColor: colorGrid.gray2,
            border: 'solid 1px' + colorGrid.gray5
          },
          focusButtonStyles: {
            backgroundColor: colorGrid.gray2
          }
        },
         //styles Change Password button
        changePwdButtonStyle : {
          buttonStyles: {
            backgroundColor: colorGrid.green8
          },
          labelStyles: {
            color: colorGrid.gray0
          },
          hoverButtonStyles: {
            backgroundColor: colorGrid.green6
          },
          focusButtonStyles: {
            backgroundColor: colorGrid.green6
          }
        }
      }
    },

    /******** SETTINGS ***********/
    settings : {
      container : {
        backgroundColor: colorGrid.gray1,
        boxShadow: '0px 2px 10px 0px' + colorGrid.gray3
      },
      selectMenuStyle : {
        containerStyle :{
          borderTop: '1px solid',
          borderLeft: '1px solid',
          borderRight: '1px solid',
          borderBottom: '1px solid',
          borderColor: colorGrid.gray3
        },
        containerStyleHover: {
          backgroundColor: colorGrid.gray2
         },
        dropDown : {
          borderTop: '0px',
          borderLeft: '1px solid',
          borderRight: '1px solid',
          borderBottom: '1px solid',
          borderColor: colorGrid.gray3
        },
        controlStyle : {
          // backgroundColor: colorGrid.gray0
        }
      },
      versionStyle:{
        color: colorGrid.gray9
      },
      //styles help & viewalerts buttons
      buttonStyle : {
        buttonStyles : {
          backgroundColor: colorGrid.gray0,
          borderTop: '1px solid',
          borderRight: '1px solid',
          borderBottom: '1px solid',
          borderLeft: '1px solid',
          borderColor: colorGrid.gray3,
          borderRadius: '2px'
        },
        labelStyles : {
          color: colorGrid.gray9
        },
        svgStyles : {
          fill: colorGrid.gray9
        },
        hoverButtonStyles : {
          backgroundColor: colorGrid.gray2,
          borderColor: colorGrid.gray5
        },
        hoverLabelStyles: {},
        hoverSvgStyles: {},
        focusButtonStyles: {},
        focusLabelStyles: {},
        focusSvgStyles: {}
      },
      logoutButtonStyle : {
        buttonStyles: {
          backgroundColor: colorGrid.red8,
          borderRadius: '2px'
        },
        labelStyles: {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.red6
        },
        svgStyles: {},
        hoverLabelStyles: {},
        hoverSvgStyles: {},
        focusButtonStyles: {},
        focusLabelStyles: {},
        focusSvgStyles: {}
      }
    },

    /******** SOFTPHONE **********/
    softphone : {
      container : {
        backgroundColor: colorGrid.gray1
        //boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.2)',
      },
      alertContainer : {
        backgroundColor: colorGrid.gray1
        //boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.2)',
      },
      callListStyles: {
        callListContainer:{

        }
      },
      buttonBarStyles: {
        buttonBar: {
          backgroundColor: colorGrid.gray1,
          boxShadow: 'inset 0px -1px 0px 0px, inset 0px 1px 0px 0px' + colorGrid.gray4
          //borderTop: '1px solid #e0e0e0',
        }
      },
      phoneButtonStyles: {
        buttonStyles : {
          backgroundColor: colorGrid.green8,
          borderRadius: '2px'
        },
        svgStyles : {
          fill: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.green6
        }
      },
      vmButtonStyles: {
        buttonStyles: {
          backgroundColor: colorGrid.gray1
          //border: 'none',
        },
        svgStyles: {
          fill: colorGrid.gray9
        }
      },
      badge : {
        badgeOptions: {
          backgroundColor: colorGrid.red8
        }
      },
      callHistoryButtonStyles: {
        buttonStyles: {
          backgroundColor: colorGrid.gray1
        }
      },
      hangupButtonStyles: {
        buttonStyles: {
          backgroundColor: colorGrid.red8,
          borderRadius: '2px'
        },
        labelStyles: {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.red6
        }
      },
      cancelButtonStyles: {
        buttonStyles: {
            backgroundColor: colorGrid.gray0,
            border: '1px solid',
            borderColor: colorGrid.gray3,
            borderRadius: '2px'
          },
          labelStyles : {
            color: colorGrid.gray9
          },
          hoverButtonStyles: {
            backgroundColor: colorGrid.gray2
        }
      },
      blindTransferButtonStyles: {
        buttonStyles : {
          border: 'none',
          backgroundColor: colorGrid.red8,
          borderRadius: '2px'
        },
        labelStyles : {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.red6
        }
      },
      attendedTransferButtonStyles: {
        buttonStyles : {
          backgroundColor: colorGrid.green8,
          borderRadius: '2px'
        },
        svgStyles : {
          fill: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.green6
        }
      },
      cancelTransferButtonStyles: {
        buttonStyles: {
          //backgroundColor: '#fff',
          //border: 'solid 1px #dedede',
        },
        labelStyles: {
          //color: '#000',
        }
      },
      dtmfHeaderStyles: {
        backgroundColor: colorGrid.gray3,
        color: colorGrid.gray9
      }
    },

    /******** UPDATE **********/
    update: {
      windowStyle:{},
      updateComp:{
        buttonStyles: {},
       labelStyles: {}
      },
      buttonBarComp : {
        buttonBar: {}
      },
      postponeComp: {
        buttonStyles: {},
        labelStyles: {}
      },
      header: {
          backgroundColor: '#6d9dc3'
      },
      msgArea:{}
    },
    /*******APPMENU(LIGHT)*********/
    appmenu : {
      appMenuContainerStyleClosed: {
        backgroundColor: colorGrid.gray3
      },
      appMenuContainerStyleOpen: {
        backgroundColor: colorGrid.gray4,
        color: colorGrid.gray9
      },
      appMenuDropdownStyle: {
        color: colorGrid.gray9
      },
      caretStyle : {
        fill : colorGrid.gray9
      },
      appMenuMotionContainerStyle: {},
      contactStatusStyle:{
        contactStatusArea: {},
        offline:{
          statusMsgArea:{
            color: colorGrid.gray9
          },
          iconStyle: {}
        },
        online: {
          statusMsgArea: {
            color: colorGrid.gray9
          },
          iconStyle: {}
        },
        busy: {
          statusMsgArea: {
            color: colorGrid.gray9
          }
        }
      },
      // styling for the phone number/DID displayed at the top of userMenu
      userInfoArea : {
        color: colorGrid.gray9
      },
      //styling for window on top checkbox container
      windowOnTop : {},
      // always on top checkbox component styles
      version: {},
      replayLogout : {},
      logoutButton : {
        buttonStyles: {},
        labelStyles: {},
        svgStyles: {},
        hoverButtonStyles: {},
        hoverLabelStyles: {},
        hoverSvgStyles: {},
        focusButtonStyles: {},
        focusLabelStyles: {},
        focusSvgStyles: {}
      },
      settingsButton:{
        buttonStyles: {
          backgroundColor: colorGrid.gray0,
          color: colorGrid.gray9
        },
        labelStyles: {
          color: colorGrid.gray9
        },
        svgStyles: {
          fill: colorGrid.gray9
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.gray2
        },
        hoverLabelStyles: {},
        hoverSvgStyles: {},
        focusButtonStyles: {},
        focusLabelStyles: {},
        focusSvgStyles: {}
      },
    },
    /*****SETTINGSNAV(LIGHT)*******/
    settingsnav : {
      settingsContainer:{
        //backgroundColor: 'purple'
        backgroundColor: colorGrid.gray2
      },
      headerStyle: {
        background: colorGrid.gray4
      },
      backButton : {
        buttonStyles : {
          background: colorGrid.gray4
        },
        svgStyles : {},
        hoverButtonStyles: {
          backgroundColor: colorGrid.gray4
        },
        focusButtonStyles: {
          backgroundColor: colorGrid.gray4
        }
      },
      settingsNavButtonStyle : {
        settingsButton: {
          backgroundColor: colorGrid.gray0,
          borderBottom: '2px solid' + colorGrid.gray2
        },
        settingsButtonLabel: {
          color: colorGrid.gray8
        },
        settingsSvg: {
          fill: colorGrid.gray8
        },
        topLabel:{},
        bottomLabel:{}
      }
    }, // end of settingsnav

    /********HEADER(LIGHT)*********/
    header : {
      headerContainer : {
        backgroundColor: colorGrid.gray3,
        borderBottom: '1px solid' + colorGrid.gray5,
      },
      contactsButtonStyle : {
        buttonStyles: {
          backgroundColor: colorGrid.gray3
        },
        svgStyles: {
          fill: colorGrid.gray9,
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.gray4,
        }
      },
      phoneButtonStyle: {
        buttonStyles: {
          backgroundColor: colorGrid.gray3,
        },
        svgStyles: {
          fill: colorGrid.gray9,
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.gray4,
        }
      },
      rightContainerStyle : {
        backgroundColor: colorGrid.gray3
      }
    },
    // END OF HEADER(LIGHT)

    /*****SETTINGSCATEGORYPAGE(LIGHT)*******/
    settingscategory : {
      settingsContainer:{
        backgroundColor: colorGrid.gray0,
        color: colorGrid.gray0
      },
      headerStyle: {
        background: colorGrid.gray4,
        //color: '#F8F9FA',
      },
      backButton : {
        buttonStyles : {
          background: colorGrid.gray4,
        },
        svgStyles : {},
        hoverButtonStyles: {
          background: colorGrid.gray5,
        },
        focusButtonStyles: {
          background: colorGrid.gray5,
        }
      },
      deleteButtonStyles: {
        buttonStyles : {},
        svgStyles : {},
        hoverButtonStyles: {
          backgroundColor: colorGrid.gray5
        },
        focusButtonStyles: {
          backgroundColor: colorGrid.gray5
        }
      },
      contactSettingCompStyle: {
        contactContainerStyles : {

        },
        importContactsCompStyle : {
          importContactSettingContainerStyle : {
            backgroundColor: colorGrid.gray0
          },
          importListContainerStyle : {},
          sectionStyle : {},
          sectionTitleStyle : {
            color: colorGrid.gray9
          },
          sectionInstructionStyle : {},
          importBackupContainerStyle : {},
          sampleButtonCompStyle : {
            buttonStyles: {},
            labelStyles: {},
            svgStyles: {},
            hoverButtonStyles: {},
            hoverLabelStyles: {},
            hoverSvgStyles: {},
            focusButtonStyles: {},
            focusLabelStyles: {},
            focusSvgStyles: {}
          },
          backupButtonCompStyle : {
            buttonStyles: {},
            labelStyles: {},
            svgStyles: {},
            hoverButtonStyles: {},
            hoverLabelStyles: {},
            hoverSvgStyles: {},
            focusButtonStyles: {},
            focusLabelStyles: {},
            focusSvgStyles: {}
          },
          importSourceListCompStyle : {
            importSourceListStyle: {},
            importSourceListItemStyle: {},
            importSourceLabelStyle: {
              color: colorGrid.gray9
            },
            logoStyle: {},
            importButtonCompStyle : {
              buttonStyles: {},
              labelStyles: {},
              svgStyles: {},
              hoverButtonStyles: {},
              hoverLabelStyles: {},
              hoverSvgStyles: {},
              focusButtonStyles: {},
              focusLabelStyles: {},
              focusSvgStyles: {}
            },
            importSourceSvgStyle: {},
          }
        }
      },
      notificationSettingStyles : {
        notificationContainerStyles : {
          backgroundColor: colorGrid.gray0,
        },
        notificationTitleStyles : {
          color: colorGrid.gray9,
        },
        notificationDescriptionStyles : {
          color: colorGrid.gray6,
        },
        selectStyles : {
          containerStyle: {
            color: colorGrid.gray9
          },
          containerStyleHover: {},
          dropDown: {
            color: colorGrid.gray9
          },
          dropDownItem: {
            color: colorGrid.gray9
          },
          hoverBackgroundColor: {},
          selectStyle: {
            color: colorGrid.gray9
          },
          disabledSelectStyle: {
            color: colorGrid.gray9
          },
          svgContainerStyle:{},
          svgStyles:{},
          controlStyle:{},
          menuOptionStyle:{},
          alertStyles : {},
          alertSVGStyles : {}
        }
      },
      appearanceSettingStyles : {
        appearanceContainerStyles : {
          backgroundColor: colorGrid.gray0,
        },
        appearanceTitleStyles : {
          color: colorGrid.gray9,
        },
        appearanceDescriptionStyles : {
          color: colorGrid.gray6,
        },
        appearanceCheckboxStyles : {
          containerStyle: {},
          input: {},
          checkbox: {},
          checkSVG: {},
          checkSVGChecked: {},
          checkboxChecked: {},
          label: {
            color: colorGrid.gray9,
          }
        },
        selectStyles : {
          containerStyle: {
            color: colorGrid.gray9
          },
          containerStyleHover: {},
          dropDown: {
            color: colorGrid.gray9
          },
          dropDownItem: {
            color: colorGrid.gray9
          },
          hoverBackgroundColor: {},
          selectStyle: {
            color: colorGrid.gray9
          },
          disabledSelectStyle: {
            color: colorGrid.gray9
          },
          svgContainerStyle:{},
          svgStyles:{},
          controlStyle:{},
          menuOptionStyle:{},
          alertStyles : {},
          alertSVGStyles : {}
        }
      }, // END OF APPEARANCESETTINGSTYLES
      deviceSettingStyles : {
        selectStyles : {
          containerStyle: {
            color: colorGrid.gray9
          },
          containerStyleHover: {},
          dropDown: {
            color: colorGrid.gray9
          },
          dropDownItem: {
            color: colorGrid.gray9
          },
          hoverBackgroundColor: {},
          selectStyle: {
            color: colorGrid.gray9
          },
          disabledSelectStyle: {
            color: colorGrid.gray9
          },
          svgContainerStyle:{},
          svgStyles:{},
          controlStyle:{},
          menuOptionStyle:{},
          alertStyles : {},
          alertSVGStyles : {}
        }
      },
      troubleshootingSettingStyles : {
        troubleshootingContainerStyles : {
          backgroundColor: colorGrid.gray0,
        },
        troubleshootingTitleStyles : {
          color: colorGrid.gray9,
        },
        troubleshootingDescriptionStyles : {
          color: colorGrid.gray6,
        },
        troubleshootingCheckboxStyles : {
          containerStyle: {},
          input: {},
          checkbox: {},
          checkSVG: {},
          checkSVGChecked: {},
          checkboxChecked: {},
          label: {
            color: colorGrid.gray9
          }
        }
      },
    }, // END OF SETTINGSCATEGORY(LIGHT)
    /*****CONTACTDETAILSCARD(LIGHT)*******/
    contactdetailscard : {
      // list zero state comp style working in route
      listZeroStateStyle : {
        zeroStateStyle: {},
         zeroSateText: {},
         //becasue we do not have the corect svg as of 4/4 this style is likely to change
         zeroStateSVG: {},
         zeroStateButtonContainer:{},
         zeroStateButtonStyle:{
            buttonStyles:{},
           labelStyles: {},
          zeroStateDescription : {}
         }
      },
      panelListStyle : {
        panelList : {},
        cardPanelOverrideStyle : {
          containerStyle : {},
          headerStyle : {},
          //removes inherent ul styles
          ul: {},
          li: {},
          panelItemStyle : {},
        },
      },
      contactCardArea: {},
      // cardDetailsOverride style working in route
      cardDetailsOverride: {
        cardDetailsDefault: {},
        cardDetailsGravatar: {},
        nameArea: {},
        topCardArea: {},
        btnWrapper: {},
        editBtn: {
          buttonStyles: {},
          labelStyles: {},
          svgStyles: {}
        },
        nameCompanyArea: {},
        entityName: {},
        entityCompanyNameStyles: {},
        deleteBtn: {
          buttonStyles: {},
          labelStyles: {},
          svgStyles: {}
        }
      },
      contactDetailsFormCompStyle : {
        formScreenStyle : {},
        formScreenHeaderStyle : {
          backgroundColor: colorGrid.gray4,
          color: colorGrid.gray9
        },
        formScreenHeaderCenterStyle : {
          backgroundColor: colorGrid.gray4,
          color: colorGrid.gray9
        },
        formErrorBarStyle : {},
        labelStyle : {
          color: colorGrid.gray9
        },
        phoneTypeLabelStyle : {},
        phoneInputLabelStyle : {},
        phoneRadioLabelStyle : {},
        contactDetailsFormStyle : {},
        fieldsetStyle : {},
        legendStyle : {},
        labelParagraphStyle : {},
        formScreenHeaderParagraphStyle : {},
        phoneNumberULStyle : {},
        phoneNumberLIStyle : {},
        phoneNumberLITopStyle : {},
        phoneNumberLIBottomStyle : {},
        deletePhoneNumberButtonCompStyle : {
          buttonStyles: {},
          labelStyles: {},
          svgStyles: {},
          hoverButtonStyles: {},
          hoverLabelStyles: {},
          hoverSvgStyles: {},
          focusButtonStyles: {},
          focusLabelStyles: {},
          focusSvgStyles: {}
        },
        // Not theming this button at this time, so removing component style properties
        addPhoneNumberButtonCompStyle : {},
        inputFieldCompStyle : {
          alertSvg: {},
          alertSvgArea: {},
          disabledInput: {},
          disabledInputNoSVG: {},
          errorText: {},
          inputAlert: {},
          //inputField: {},
          inputFieldNoSVG: {},
          //inputFieldWithError: {},
          inputFieldWithErrorNoSVG: {},
          //inputFieldWithHover: {},
          inputFieldWithHoverNoSVG: {},
          //inputFieldWithFocus: {},
          inputFieldWithFocusNoSVG: {},
          inputComponent: {},
          inputContainer: {},
          showHide: {},
          showHideWithError: {},
          svgArea: {},
          noSVGArea: {},
          svgAreaWithError: {},
          svgAreaWithFocus: {},
          svgAreaWithHover: {},
          svgStyle: {},
          svgStyleChange: {},
          svgStyleWithHover: {},
          noSvgStyle: {}
        },
        selectCompStyle : {
          containerStyle: {},
          containerStyleHover: {},
          dropDown: {},
          dropDownItem: {},
          hoverBackgroundColor: {},
          selectStyle: {},
          disabledSelectStyle: {},
          svgContainerStyle:{},
          svgStyles:{},
          controlStyle:{},
          menuOptionStyle:{},
          alertStyles : {},
          alertSVGStyles : {}
        },
        saveButtonCompStyle : {
          buttonStyles: {},
          labelStyles: {},
          svgStyles: {},
          hoverButtonStyles: {},
          hoverLabelStyles: {},
          hoverSvgStyles: {},
          focusButtonStyles: {},
          focusLabelStyles: {},
          focusSvgStyles: {}
        },
        cancelButtonCompStyle : {
          buttonStyles: {
            border : '1px solid'+ colorGrid.gray5
          },
          labelStyles: {
            //color: colorGrid.gray9
          },
          svgStyles: {
            color: colorGrid.gray9
          },
          hoverButtonStyles: {
            backgroundColor: colorGrid.gray5
          },
          hoverLabelStyles: {},
          hoverSvgStyles: {},
          focusButtonStyles: {
            backgroundColor: colorGrid.gray5
          },
          focusLabelStyles: {},
          focusSvgStyles: {}
        },
        backButtonCompStyle: {
          buttonStyles: {
            color: colorGrid.gray9
          },
          labelStyles: {
            color: colorGrid.gray9
          },
          svgStyles: {},
          hoverButtonStyles: {
            backgroundColor: colorGrid.gray5
          },
          hoverLabelStyles: {
            color: colorGrid.gray9
          },
          hoverSvgStyles: {},
          focusButtonStyles: {
            backgroundColor: colorGrid.gray5
          },
          focusLabelStyles: {},
          focusSvgStyles: {}
        },
      },
      // modal override styles
      modalContentOverrideStyle : {
        modalContentStyle : {
          backgroundColor: colorGrid.gray9,
          //boxShadow : '0 6px 16px 0 rgba(3, 3, 4, 0.26)',
        },

        headerTextStyle : {
          color: colorGrid.gray0,
        },

        descriptionTextStyle : {
          //color: colorGrid.gray5,
        },

        buttonContainerStyle : {},

        cancelButtonStyle : {
          buttonStyles : {
            // backgroundColor: colorGrid.gray1,
            //border: '1px solid'+ colorGrid.gray3,
          },
          labelStyles : {
            //color: colorGrid.gray9
          }
         },

         deleteButtonStyle : {
          buttonStyles : {
            // backgroundColor: colorGrid.red7,
          },
          labelStyles : {
            // color: colorGrid.gray1
          }
         },
      }
    }



  },


  // ******************************
  // ****         Dark         ****
  // ******************************

  Dark: {


        /******** ALERT ITEM *********/
        alertitem : {
          alertItemStyles : {

          },
          detailTextStyle:{
            color: colorGrid.gray0
          },
          errorBorderStyles : {
            borderBottom: '4px solid ' + colorGrid.red9,
            borderLeft: '4px solid ' + colorGrid.red9,
            borderRight: '4px solid ' + colorGrid.red9,
            borderTop: '4px solid ' + colorGrid.red9
          },
          warnBorderStyles : {
            borderBottom: '4px solid ' + colorGrid.orange9,
            borderLeft: '4px solid ' + colorGrid.orange9,
            borderRight: '4px solid ' + colorGrid.orange9,
            borderTop: '4px solid ' + colorGrid.orange9
          },
          infoBorderStyles : {
            borderBottom: '4px solid ' + colorGrid.green9,
            borderLeft: '4px solid ' + colorGrid.green9,
            borderRight: '4px solid ' + colorGrid.green9,
            borderTop: '4px solid ' + colorGrid.green9
          },
          errorDetailStyle:{
            backgroundColor: colorGrid.red9
          },
          warnDetailStyle:{
            backgroundColor: colorGrid.orange9
          },
          infoDetailStyle:{
            backgroundColor: colorGrid.green9
          },
          errorBackgroundStyles : {
            backgroundColor: colorGrid.red8
          },
          warnBackgroundStyles : {
            backgroundColor: colorGrid.orange8
          },
          infoBackgroundStyles : {
            backgroundColor: colorGrid.green8
          },
          headingStyles: {
            //color: colorGrid.gray0
          },
          alertSvgStyles : {
            fill: colorGrid.gray0
          },
          closeSvgStyles : {
            //fill: '#8c0112'
          },
          alertDetailStyle : {
            backgroundColor: colorGrid.gray0
          },
          errorCloseSvgStyles : {
            fill: colorGrid.red2
          },
          warnCloseSvgStyles : {
            fill: colorGrid.orange2
          },
          infoCloseSvgStyles : {
            fill: colorGrid.green2
          }
        },

        /********* ALERT LOG *********/
        alertlog : {
          headerArea : {
            backgroundColor: colorGrid.gray8,
            color: colorGrid.gray0
          },
          headerText:{
            color: colorGrid.gray0
          },
          clearAlerts: {
            buttonStyles: {
              backgroundColor: colorGrid.gray8
            },
            labelStyles:{
              color: colorGrid.gray0
            }
          },
          backIconArea: {
            buttonStyles: {
              backgroundColor: colorGrid.gray8
            },
            labelStyles:{
              color: colorGrid.gray0
            },
            svgStyles:{
              fill: colorGrid.gray0
            }
          },
          listArea : {
            backgroundColor: colorGrid.gray8
          },
          dateSeparator : {
              // boxShadow: 'inset 0px 1px 0px 0px, inset 0px -1px 0px 0px' + colorGrid.gray3,
              color: colorGrid.gray2,
              backgroundColor: colorGrid.gray8
          },
          noAlerts : {
            boxShadow: 'inset 0 1px 0 0' + colorGrid.gray3
          },
          noAlertText: {
            color: colorGrid.gray0
          },
          noAlertIcon:{
            fill: colorGrid.gray2
          }
        },

        /******* CALL CONTROLS *******/
        callcontrols : {
          callControlsWrapStyles: {
            backgroundColor: colorGrid.gray9
          },
          hoverStyle: {
            hoverButtonStyles: {
              backgroundColor: colorGrid.gray8,
              color: colorGrid.gray0,
              borderBottom: 'none',
              borderLeft: 'none',
              borderRight: 'none',
              borderTop: 'none',
              borderColor: 'transparent'
            },
            hoverLabelStyles: {
              color: colorGrid.gray0
            },
            hoverSvgStyles: {
              fill: colorGrid.gray0
            }
          },
          focusStyle: {
            focusButtonStyles: {
              border: '2px solid transparent',
              backgroundColor: colorGrid.gray9
            },
            focusLabelStyles: {
              color: colorGrid.gray0
            },
            focusSvgStyles: {
              fill: colorGrid.gray0
            }
          },
          // area that contains top two button bars
          topContainer: {
            backgroundColor: colorGrid.gray9
          },
          audioControlBtn: {
            buttonStyles: {
              border: '2px solid transparent',
              backgroundColor: colorGrid.gray9
            },
            labelStyles: {
              color: colorGrid.gray0
            },
            svgStyles: {
              fill: colorGrid.gray0
            }
          },
          holdButton: {
            buttonStyles: {
              border: '2px solid transparent',
              backgroundColor: colorGrid.gray9
            },
            labelStyles: {
              color: colorGrid.gray0
            },
            svgStyles: {
              fill: colorGrid.gray0
            }
          },
          isMutedHeldButtons: {
            buttonStyles: {
              //border : '2px solid'+colorGrid.gray2,
              //backgroundColor: colorGrid.gray2
            },
            labelStyles: {
              color: colorGrid.gray0
            },
            svgStyles: {
              fill: colorGrid.gray0
            }
          },
          genericButton: {
            buttonStyles: {
              borderBottom: 'none',
              borderLeft: 'none',
              borderRight: 'none',
              borderTop: 'none',
              border: '2px solid transparent',
              backgroundColor: colorGrid.gray9
            },
            labelStyles: {
              color: colorGrid.gray0
            },
            svgStyles: {
              fill: colorGrid.gray0
            }
          },
          // area that contains bottom buttonbar
          bottomContainer: {

          },
          hangupButton: {
            buttonStyles: {
              backgroundColor: colorGrid.red8,
              borderBottom: 'none',
              borderLeft: 'none',
              borderRight: 'none',
              borderTop: 'none',
              borderRadius: '2px'
            },
            labelStyles: {
              color: colorGrid.gray0
            },
            hoverButtonStyles: {
              backgroundColor: colorGrid.red6
            }
          },
          transferButton: {
            buttonStyles : {
              backgroundColor: colorGrid.green8,
              borderRadius: '2px'
            },
            labelStyles : {
              color: colorGrid.gray0
            },
            hoverButtonStyles: {
              backgroundColor: colorGrid.green6
            }
          },
          disabledByAttendedTransfer: {
            buttonStyles: {
              border: '2px solid transparent',
              backgroundColor: colorGrid.gray9
            },
            labelStyles: {
              color: colorGrid.gray0
            },
            svgStyles: {
              fill: colorGrid.gray0
            }
          },
          audioControlCompStyles : {
            audioControlComponent: {
              backgroundColor: colorGrid.gray8
            },
            audioSettingArea: {
              borderTop: '0px',
              borderRight: '0px',
              borderLeft: '0px',
              borderBottom: '1px solid',
              borderColor: colorGrid.gray3
            },
            buttonBarArea: {},
            controls: {},
            heading: {
              color: colorGrid.gray0
            },
            section: {
              backgroundColor: colorGrid.gray8
            },
            selection: {
              color: colorGrid.gray1,
              backgroundColor: colorGrid.gray8
            },
            selectStyle : {
              containerStyle :{
                backgroundColor: colorGrid.gray7,
                borderTop: '1px solid',
                borderLeft: '1px solid',
                borderRight: '1px solid',
                borderBottom: '1px solid',
                borderColor: colorGrid.gray4
              },
              containerStyleHover: {
                backgroundColor: colorGrid.gray6,
                 borderTop: '1px solid' + colorGrid.gray4,
                 borderLeft: '1px solid' + colorGrid.gray4,
                 borderRight:  '1px solid' + colorGrid.gray4,
                 borderBottom:  '1px solid' + colorGrid.gray4
                //  borderColor: colorGrid.gray4
               },
              dropDown : {
                backgroundColor : colorGrid.gray5,
                borderTop: '0px',
                borderLeft: '1px solid',
                borderRight: '1px solid',
                borderBottom: '1px solid',
                borderColor: colorGrid.gray4,
                color: colorGrid.gray8
              },
              controlStyle : {
                // backgroundColor : colorGrid.gray7,
                color: colorGrid.gray1
              }


              //backgroundColor: colorGrid.gray7
              // containerStyleHover: {
              //   backgroundColor: colorGrid.gray6
              // },
              // dropDown: {
              //   backgroundColor: colorGrid.gray1,
              //   color: colorGrid.gray8
              // },
              // hoverBackgroundColor: {
              //   backgroundColor: colorGrid.gray2
              // }
            },
            slider: {
              fill: colorGrid.gray0
            },
            buttonBarCompStyle: {
              buttonBar: {
                backgroundColor: colorGrid.gray8
              }
            },
            saveBtnCompStyle: {
              buttonStyles : {
                backgroundColor: colorGrid.green8,
                borderTopLeftRadius: '2px',
                borderTopRightRadius: '2px',
                borderBottomLeftRadius: '2px',
                borderBottomRightRadius: '2px'
              },
              labelStyles : {
                color: colorGrid.gray0
              },
              hoverButtonStyles: {
                backgroundColor: colorGrid.green6
              }
            },
            cancelBtnCompStyle: {
              buttonStyles : {
                backgroundColor: colorGrid.gray7,
                borderTop: '1px solid',
                borderRight: '1px solid',
                borderBottom: '1px solid',
                borderLeft: '1px solid',
                borderColor: colorGrid.gray4,
                borderRadius: '2px'
              },
              labelStyles : {
                color: colorGrid.gray0
              },
              hoverButtonStyles : {
                backgroundColor: colorGrid.gray5
              }
            }
          }
        },

        /******* CALL DETAIL *********/
        calldetail : {
          selectedCallDetailItem:{
            backgroundColor: colorGrid.gray0,
            color: colorGrid.gray8
          },
          unselectedCallDetailItem:{
            backgroundColor: colorGrid.gray8,
            color: colorGrid.gray0,
            fill: colorGrid.gray0
          },
          selectedSVG: {
            fill: colorGrid.gray9
          },
          unselectedSVG: {
            fill: colorGrid.gray0
          },
          statusCompStyle: {
            statusSvgStyle: {
              fill: colorGrid.gray0
            }
          }
        },

        /******* CALL HISTORY ********/
        callhistory : {
          callHistoryContainer:{
            backgroundColor: colorGrid.gray8
          },
          header: {
            backgroundColor: colorGrid.gray8,
            color: colorGrid.gray0,
            boxShadow: 'inset 0 1px 0 0, inset 0 -1px 0 0' + colorGrid.gray4
          },
          noHistoryMsg:{
            color: colorGrid.gray0
          },
          noCallHistory: {
            backgroundColor: colorGrid.gray8
          },
          dateHeading: {
            backgroundColor: colorGrid.gray8,
            color: colorGrid.gray2
          },
          backBtn: {
            buttonStyles: {
              borderBottom: 'none',
              borderLeft: 'none',
              borderRight: 'none',
              borderTop: 'none',
              borderRadius: '0px'
            },
            labelStyles: {
              color: colorGrid.gray0
            },
            svgStyles: {
              fill: colorGrid.gray0
            }
          },
          clearBtn: {
            buttonStyles: {
              borderBottom: 'none',
              borderLeft: 'none',
              borderRight: 'none',
              borderTop: 'none',
              borderRadius: '0px'
            },
            labelStyles: {
              color: colorGrid.gray0
            },
            svgStyles: {
              fill: colorGrid.gray0
            }
          },
          callDetailComp:{
            unselectedCallDetailItem:{
              backgroundColor: colorGrid.gray8,
              color: colorGrid.gray0
            },
            callDirectionSVG: {
              fill: colorGrid.gray2
            },
            statusArea: {
              color: colorGrid.red8
            },
            infoArea: {
              color: colorGrid.gray2
            }
          }
        },

        /******** CALL LIST **********/
        calllist : {
          callDetailList: {},
          callList: {
            backgroundColor: colorGrid.gray8
          },
          callListContainer:{
            backgroundColor: colorGrid.gray8
              },
          defaultMsg: {},
          divider: {},
          listItem: {},
          listHeader: {},
          svg: {

          },
          transferDetailComp: {
            selectedCallDetailItem:{
              backgroundColor: colorGrid.gray0,
              color: colorGrid.gray9
            },
            unselectedCallDetailItem:{
              backgroundColor: colorGrid.gray8,
              color: colorGrid.gray0
            }
          },
          callDetailComp: {
            unselectedCallDetailItem:{
              backgroundColor: colorGrid.gray8,
              color: colorGrid.gray0
            },
            selectedCallDetailItem:{
              backgroundColor: colorGrid.gray0,
              boxShadow: 'inset 0px -1px 0px 0px, inset 0px 1px 0px 0px' + colorGrid.gray5
            },
            timerMute: {

            },
            callDirectionSVG: {
              fill:  colorGrid.gray8
            },
            statusArea: {},
            infoArea: {},
            callerId: {},
            callerIdName:{},
            callerExt:{},
            callStatus: {},
            svgArea: {},
            statusCompStyle: {
              statusSvgStyle:{},
              statusConnectedSvgStyle: {},
              statusStyle: {},
              messageStyle:{}
            }
          }
        },

        /******* DIALING INPUT *******/
        dialinginput : {
          dialingInputFocused : {
            backgroundColor: colorGrid.gray6
          },
          dialingInputUnfocused : {
            backgroundColor: colorGrid.gray7,
            boxShadow: 'inset 0px 1px 0px, inset 0px -1px 0px 0px' + colorGrid.gray4,
            color: colorGrid.gray0
          },
          inputFocused : {
            backgroundColor: colorGrid.gray6
          },
          inputUnfocused : {
            backgroundColor: colorGrid.gray7
          },
          placeholderColor : {
            color: colorGrid.gray1
          }
        },

        /**********HEADER(DARK)*********/
        header : {
          headerContainer : {
            backgroundColor: colorGrid.gray9,
            borderBottom: '1px solid' + colorGrid.gray8,
          },
          contactsButtonStyle : {
            buttonStyles: {
              backgroundColor: colorGrid.gray9
            },
            svgStyles: {
              fill: colorGrid.gray0,
            },
            hoverButtonStyles: {
              backgroundColor: colorGrid.gray7,
            }

          },
          phoneButtonStyle: {
            buttonStyles: {
              backgroundColor: colorGrid.gray9,
            },
            svgStyles: {
              fill: colorGrid.gray0,
            },
            hoverButtonStyles: {
              backgroundColor: colorGrid.gray7,
            }
          },
          rightContainerStyle : {
            backgroundColor: colorGrid.gray9
          }
        },
        // END OF HEADER(DARK)

        /****** INCOMING CALL ********/
        incomingcall : {
          acceptComp:{
              buttonStyles : {
                borderBottom: 'none',
                borderLeft: 'none',
                borderRight: 'none',
                borderTop: 'none',
                backgroundColor: colorGrid.green8,
                borderRadius: '2px'
              },
              labelStyles : {
                color: colorGrid.gray0
              },
              hoverButtonStyles: {
                backgroundColor: colorGrid.green6
              }
          },
          callDetailComp: {
            unselectedCallDetailItem:{
              backgroundColor: colorGrid.gray8,
              color: colorGrid.gray0
            }
          },
          declineComp: {
            buttonStyles : {
              borderBottom: 'none',
              borderLeft: 'none',
              borderRight: 'none',
              borderTop: 'none',
              backgroundColor: colorGrid.red8,
              borderRadius: '2px'
            },
            labelStyles : {
              color: colorGrid.gray0
            },
            hoverButtonStyles: {
              backgroundColor: colorGrid.red6
            }
          },
          header: {
            backgroundColor: colorGrid.gray8,
            color: colorGrid.gray0
          },
          incomingCallContainer:{
            backgroundColor: colorGrid.gray8
          },
          voicemailComp: {
            buttonStyles : {
              backgroundColor: colorGrid.gray0,
              borderBottom: '1px solid',
              borderLeft: '1px solid',
              borderRight: '1px solid',
              borderTop: '1px solid',
              borderColor: colorGrid.gray3
            },
            labelStyles : {
              color: colorGrid.gray9
            },
            hoverButtonStyles : {
              backgroundColor: colorGrid.gray2
            }
          }
        },

        /********** KEYPAD ***********/
        keypad : {
          wrapper: {
            backgroundColor: colorGrid.gray9
          },
          KeyItemContainer : {
            backgroundColor: colorGrid.gray9
          },
          keypadItem: {
            container: {
              //border: '1px solid transparent',
              color: colorGrid.gray0,
              backgroundColor: colorGrid.gray9,
              ':hover': {
                color: colorGrid.gray0,
                backgroundColor: colorGrid.gray7,
                borderTop: '1px solid',
                borderRight: '1px solid',
                borderBottom: '1px solid',
                borderLeft: '1px solid',
                borderColor: colorGrid.gray9,
                borderTopLeftRadius: '2px',
                borderTopRightRadius: '2px',
                borderBottomLeftRadius: '2px',
                borderBottomRightRadius: '2px'
              },
              ':active': {
                color: colorGrid.gray9,
                backgroundColor: colorGrid.gray0,
                borderTop: '1px solid',
                borderRight: '1px solid',
                borderBottom: '1px solid',
                borderLeft: '1px solid',
                borderColor: colorGrid.gray9,
                borderTopLeftRadius: '2px',
                borderTopRightRadius: '2px',
                borderBottomLeftRadius: '2px',
                borderBottomRightRadius: '2px'
              },
              ':focus': {
                color: colorGrid.gray9,
                backgroundColor: colorGrid.gray0,
                borderTopLeftRadius: '2px',
                borderTopRightRadius: '2px',
                borderBottomLeftRadius: '2px',
                borderBottomRightRadius: '2px'
              }
            }
          },
          textArea : {
            color: colorGrid.gray9
          },
          keyValue: {
            color: colorGrid.gray9
          },
          keyString: {
            color: colorGrid.gray9
          }
        },

        /********** LOGIN ************/
        login : {
          //styles forgot password block
          forgot : {
            loginBlockForgot : {
              backgroundColor: colorGrid.gray8
            },
            textAreaStyle: {
              color: colorGrid.gray0
            },
          //styles input field
            labelledInputForgotStyle : {
              inputField: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '1px solid' + colorGrid.gray3,
                borderLeft: 'none',
                borderRight: '1px solid' + colorGrid.gray3,
                borderTop: '1px solid' + colorGrid.gray3,
                color: colorGrid.gray0
              },
              inputFieldWithError: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '2px solid' + colorGrid.red8,
                borderLeft: 'none',
                borderRight: '2px solid' + colorGrid.red8,
                borderTop: '2px solid' + colorGrid.red8,
                color: colorGrid.gray0
              },
              inputFieldWithFocus: {
                backgroundColor : colorGrid.gray7,
                borderTop: 'solid 2px' + colorGrid.blue6,
                borderLeft: 'none',
                borderBottom: 'solid 2px' + colorGrid.blue6,
                borderRight: 'solid 2px' + colorGrid.blue6,
                color: colorGrid.gray0
              },
              inputFieldWithHover: {
                backgroundColor: colorGrid.gray6,
                borderBottom: '1px solid' + colorGrid.gray5,
                borderLeft: 'none',
                borderRight: '1px solid' + colorGrid.gray5,
                borderTop: '1px solid' + colorGrid.gray5,
                color: colorGrid.gray0
              },
              showHide: {},
              svgArea: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '1px solid' + colorGrid.gray3,
                borderLeft: '1px solid' + colorGrid.gray3,
                borderRight: '1px solid' + colorGrid.gray3,
                borderTop: '1px solid' + colorGrid.gray3
              },
              svgAreaWithHover: {
                backgroundColor: colorGrid.gray6,
                borderBottom: '1px solid' + colorGrid.gray5,
                borderLeft: '1px solid' + colorGrid.gray5,
                borderRight: '1px solid' + colorGrid.gray5,
                borderTop: '1px solid' + colorGrid.gray5
              },
              svgStyle: {
                fill: colorGrid.gray0
              },
              svgStyleWithHover: {
                fill: colorGrid.gray0
              },
              hintStyle: {
                color: colorGrid.gray6
              },
              hintWithFocusStyle: {
                color: colorGrid.blue6
              },
              hintWithErrorStyle: {
                color: colorGrid.red8
              },
              inputLabelStyle: {
                color: colorGrid.gray0
              }
            },
           //styles button area
            buttonAreaForgot: {},
          //styles cancel button
            cancelButtonStyle : {
              buttonStyles: {
                backgroundColor: colorGrid.gray0,
                borderBottom: 'solid 1px' + colorGrid.gray3,
                borderLeft: 'solid 1px' + colorGrid.gray3,
                borderRight: 'solid 1px' + colorGrid.gray3,
                borderTop: 'solid 1px' + colorGrid.gray3
              },
              labelStyles: {
                color: colorGrid.gray9
              },
              hoverButtonStyles: {
                backgroundColor: colorGrid.gray2,
                borderBottom: 'solid 1px' + colorGrid.gray5,
                borderLeft: 'solid 1px' + colorGrid.gray5,
                borderRight: 'solid 1px' + colorGrid.gray5,
                borderTop: 'solid 1px' + colorGrid.gray5
              },
              focusButtonStyles: {
                backgroundColor: colorGrid.gray2
              }
            },
             //styles reset password button
            resetButtonStyle : {
              buttonStyles: {
                backgroundColor: colorGrid.green8
              },
              labelStyles: {
                color: colorGrid.gray0
              },
              hoverButtonStyles: {
                backgroundColor: colorGrid.green6
              },
              focusButtonStyles: {
                backgroundColor: colorGrid.green6
              }
            }
          }, //end forgot password block
          login: {},
          loginForm: {
            loginBlockStyle: {
              backgroundColor: colorGrid.gray8
            },
            //styles top labelled input field
            labelledInputEmailStyle : {
              inputField: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '1px solid' + colorGrid.gray3,
                borderLeft: 'none',
                borderRight: '1px solid' + colorGrid.gray3,
                borderTop: '1px solid' + colorGrid.gray3,
                color: colorGrid.gray0
              },
              inputFieldWithError: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '2px solid' + colorGrid.red8,
                borderLeft: 'none',
                borderRight: '2px solid' + colorGrid.red8,
                borderTop: '2px solid' + colorGrid.red8,
                color: colorGrid.gray0
              },
              inputFieldWithFocus: {
                backgroundColor : colorGrid.gray7,
                borderTop: 'solid 2px' + colorGrid.blue6,
                borderLeft: 'none',
                borderBottom: 'solid 2px' + colorGrid.blue6,
                borderRight: 'solid 2px' + colorGrid.blue6,
                color: colorGrid.gray0
              },
              inputFieldWithHover: {
                backgroundColor: colorGrid.gray6,
                borderBottom: '1px solid' + colorGrid.gray5,
                borderLeft: 'none',
                borderRight: '1px solid' + colorGrid.gray5,
                borderTop: '1px solid' + colorGrid.gray5,
                color: colorGrid.gray0
              },
              showHide: {},
              svgArea: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '1px solid' + colorGrid.gray3,
                borderLeft:'1px solid' + colorGrid.gray3,
                borderRight:'1px solid' + colorGrid.gray3,
                borderTop:'1px solid' + colorGrid.gray3
              },
              svgAreaWithHover: {
                backgroundColor: colorGrid.gray6,
                borderBottom: '1px solid' + colorGrid.gray5,
                borderLeft:'1px solid' + colorGrid.gray5,
                borderRight:'1px solid' + colorGrid.gray5,
                borderTop:'1px solid' + colorGrid.gray5
              },
              svgStyle: {
                fill: colorGrid.gray0
              },
              svgStyleWithHover: {
                fill: colorGrid.gray0
              },
              hintStyle: {
                color: colorGrid.gray6
              },
              hintWithFocusStyle: {
                color: colorGrid.blue6
              },
              hintWithErrorStyle: {
                color: colorGrid.red8
              },
              inputLabelStyle: {
                color: colorGrid.gray0
              }
            },
            //styles password input field
            labelledInputPasswordStyle : {
              inputField: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '1px solid' + colorGrid.gray3,
                borderLeft: 'none',
                borderRight: '1px solid' + colorGrid.gray3,
                borderTop: '1px solid' + colorGrid.gray3,
                color: colorGrid.gray0
              },
              inputFieldWithError: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '2px solid' + colorGrid.red8,
                borderLeft: 'none',
                borderRight: '2px solid' + colorGrid.red8,
                borderTop: '2px solid' + colorGrid.red8,
                color: colorGrid.gray0
              },
              inputFieldWithFocus: {
                backgroundColor : colorGrid.gray7,
                borderTop: 'solid 2px' + colorGrid.blue6,
                borderLeft: 'none',
                borderBottom: 'solid 2px' + colorGrid.blue6,
                borderRight: 'solid 2px' + colorGrid.blue6,
                color: colorGrid.gray0
              },
              inputFieldWithHover: {
                backgroundColor: colorGrid.gray6,
                borderBottom: '1px solid' + colorGrid.gray5,
                borderLeft: 'none',
                borderRight: '1px solid' + colorGrid.gray5,
                borderTop: '1px solid' + colorGrid.gray5,
                color: colorGrid.gray0
              },
              showHide: {
                color: colorGrid.gray1
              },
              svgArea: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '1px solid' + colorGrid.gray3,
                borderLeft: '1px solid' + colorGrid.gray3,
                borderRight: '1px solid' + colorGrid.gray3,
                borderTop: '1px solid' + colorGrid.gray3
              },
              svgAreaWithHover: {
                backgroundColor: colorGrid.gray6,
                borderBottom: '1px solid' + colorGrid.gray5,
                borderLeft: '1px solid' + colorGrid.gray5,
                borderRight: '1px solid' + colorGrid.gray5,
                borderTop: '1px solid' + colorGrid.gray5
              },
              svgStyle: {
                fill: colorGrid.gray0
              },
              svgStyleWithHover: {
                fill: colorGrid.gray0
              },
              hintStyle: {
                color: colorGrid.gray6
              },
              hintWithFocusStyle: {
                color: colorGrid.blue6
              },
              hintWithErrorStyle: {
                color: colorGrid.red8
              },
              inputLabelStyle: {
                color: colorGrid.gray0
              }
            },
            // area that contains checkbox and forgot password
            linkWrapper: {},
             //styles checkbox/link area
            checkboxForgotPWAreaStyle: {},
            //styles the checkbox
            checkboxStyle: {
              checkbox: {
                backgroundColor: colorGrid.gray7
              },
              checkboxChecked: {
                backgroundColor: colorGrid.blue6
              },
              label: {
                color: colorGrid.gray0
              }
            },
            //styles forgot password button
            forgotButtonBottomStyle: {
              color: colorGrid.blue6
            },
             //styles forgot password button
            forgotButtonRightStyle: {
              color: colorGrid.blue6
            },
            //styles button area
            buttonArea : {},
            //styles sign in button
            buttonStyle : {
              buttonStyles: {
                backgroundColor: colorGrid.green8
              },
              labelStyles: {
                color: colorGrid.gray0
              },
              hoverButtonStyles: {
                backgroundColor: colorGrid.green6
              },
              focusButtonStyles: {
                backgroundColor: colorGrid.green6
              }
            }
          }, //end login block
          //styles reset block
          reset : {
            loginBlockReset: {
              backgroundColor: colorGrid.gray8
            },
            textAreaResetStyle: {
              color: colorGrid.gray0
            },
            //styles top password input field
            inputPasswordResetStyle : {
              inputField: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '1px solid' + colorGrid.gray3,
                borderLeft: 'none',
                borderRight: '1px solid' + colorGrid.gray3,
                borderTop: '1px solid' + colorGrid.gray3,
                color: colorGrid.gray0
              },
              inputFieldWithError: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '2px solid' + colorGrid.red8,
                borderLeft: 'none',
                borderRight: '2px solid' + colorGrid.red8,
                borderTop: '2px solid' + colorGrid.red8,
                color: colorGrid.gray0
              },
              inputFieldWithFocus: {
                backgroundColor : colorGrid.gray7,
                borderTop: 'solid 2px' + colorGrid.blue6,
                borderLeft: 'none',
                borderBottom: 'solid 2px' + colorGrid.blue6,
                borderRight: 'solid 2px' + colorGrid.blue6,
                color: colorGrid.gray0
              },
              inputFieldWithHover: {
                backgroundColor: colorGrid.gray6,
                borderBottom: '1px solid' + colorGrid.gray5,
                borderLeft: 'none',
                borderRight: '1px solid' + colorGrid.gray5,
                borderTop: '1px solid' + colorGrid.gray5,
                color: colorGrid.gray0
              },
              showHide: {
                color: colorGrid.gray1
              },
              svgArea: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '1px solid' + colorGrid.gray3,
                borderLeft: '1px solid' + colorGrid.gray3,
                borderRight: '1px solid' + colorGrid.gray3,
                borderTop: '1px solid' + colorGrid.gray3
              },
              svgAreaWithHover: {
                backgroundColor: colorGrid.gray6,
                borderBottom: '1px solid' + colorGrid.gray5,
                borderLeft: '1px solid' + colorGrid.gray5,
                borderRight: '1px solid' + colorGrid.gray5,
                borderTop: '1px solid' + colorGrid.gray5
              },
              svgStyle: {
                fill: colorGrid.gray0
              },
              svgStyleWithHover: {
                fill: colorGrid.gray0
              },
              hintStyle: {
                color: colorGrid.gray6
              },
              hintWithFocusStyle: {
                color: colorGrid.blue6
              },
              hintWithErrorStyle: {
                color: colorGrid.red8
              },
              inputLabelStyle: {
                color: colorGrid.gray0
              }
            },
            inputBottomPasswordStyle : {
              labelledInputComponentStyle: {},
              inputField: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '1px solid' + colorGrid.gray3,
                borderLeft: 'none',
                borderRight: '1px solid' + colorGrid.gray3,
                borderTop: '1px solid' + colorGrid.gray3,
                color: colorGrid.gray0
              },
              inputFieldWithError: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '2px solid' + colorGrid.red8,
                borderLeft: 'none',
                borderRight: '2px solid' + colorGrid.red8,
                borderTop: '2px solid' + colorGrid.red8,
                color: colorGrid.gray0
              },
              inputFieldWithFocus: {
                backgroundColor : colorGrid.gray7,
                borderTop: 'solid 2px' + colorGrid.blue6,
                borderLeft: 'none',
                borderBottom: 'solid 2px' + colorGrid.blue6,
                borderRight: 'solid 2px' + colorGrid.blue6,
                color: colorGrid.gray0
              },
              inputFieldWithHover: {
                backgroundColor: colorGrid.gray6,
                borderBottom: '1px solid' + colorGrid.gray5,
                borderLeft: 'none',
                borderRight: '1px solid' + colorGrid.gray5,
                borderTop: '1px solid' + colorGrid.gray5,
                color: colorGrid.gray0
              },
              showHide: {
                color: colorGrid.gray1
              },
              svgArea: {
                backgroundColor: colorGrid.gray7,
                borderBottom: '1px solid' + colorGrid.gray3,
                borderLeft: '1px solid' + colorGrid.gray3,
                borderRight: '1px solid' + colorGrid.gray3,
                borderTop: '1px solid' + colorGrid.gray3
              },
              svgAreaWithHover: {
                backgroundColor: colorGrid.gray6,
                borderBottom: '1px solid' + colorGrid.gray5,
                borderLeft: '1px solid' + colorGrid.gray5,
                borderRight: '1px solid' + colorGrid.gray5,
                borderTop: '1px solid' + colorGrid.gray5
              },
              svgStyle: {
                fill: colorGrid.gray0
              },
              svgStyleWithHover: {
                fill: colorGrid.gray0
              },
              hintStyle: {
                color: colorGrid.gray6
              },
              hintWithFocusStyle: {
                color: colorGrid.blue6
              },
              hintWithErrorStyle: {
                color: colorGrid.red8
              },
              inputLabelStyle: {
                color: colorGrid.gray0
              }
            },
             //styles button area
            buttonAreaReset: {},
             //styles cancel button
            notNowButtonStyle : {
              buttonStyles: {
                backgroundColor: colorGrid.gray0,
                borderBottom: '1px solid' + colorGrid.gray3,
                borderLeft: '1px solid' + colorGrid.gray3,
                borderRight: '1px solid' + colorGrid.gray3,
                borderTop: '1px solid' + colorGrid.gray3
              },
              labelStyles: {
                color: colorGrid.gray9
              },
              hoverButtonStyles: {
                backgroundColor: colorGrid.gray2,
                borderBottom: '1px solid' + colorGrid.gray5,
                borderLeft: '1px solid' + colorGrid.gray5,
                borderRight: '1px solid' + colorGrid.gray5,
                borderTop: '1px solid' + colorGrid.gray5
              },
              focusButtonStyles: {
                backgroundColor: colorGrid.gray2
              }
            },
             //styles Change Password button
            changePwdButtonStyle : {
              buttonStyles: {
                backgroundColor: colorGrid.green8
              },
              labelStyles: {
                color: colorGrid.gray0
              },
              hoverButtonStyles: {
                backgroundColor: colorGrid.green6
              },
              focusButtonStyles: {
                backgroundColor: colorGrid.green6
              }
            }
          }
        },

        /******** SETTINGS ***********/
        settings : {
          container : {
            backgroundColor: colorGrid.gray8,
            boxShadow: '0px 2px 10px 0px' + colorGrid.gray2
          },
          selectMenuStyle : {
            containerStyle :{
              backgroundColor: colorGrid.gray7,
              borderTop: '1px solid',
              borderLeft: '1px solid',
              borderRight: '1px solid',
              borderBottom: '1px solid',
              borderColor: colorGrid.gray4
            },
            containerStyleHover: {
              backgroundColor: colorGrid.gray6,
               borderTop: '1px solid' + colorGrid.gray4,
               borderLeft: '1px solid' + colorGrid.gray4,
               borderRight:  '1px solid' + colorGrid.gray4,
               borderBottom:  '1px solid' + colorGrid.gray4
              //  borderColor: colorGrid.gray4
             },
            dropDown : {
              backgroundColor : colorGrid.gray5,
              borderTop: '0px',
              borderLeft: '1px solid',
              borderRight: '1px solid',
              borderBottom: '1px solid',
              borderColor: colorGrid.gray4
            },
            controlStyle : {
              // backgroundColor : colorGrid.gray7,
              color: colorGrid.gray1
            }
          },
          selectHeader : {
            color: colorGrid.gray1
          },
          checkboxStyle: {
            checkboxChecked: {
              backgroundColor: colorGrid.blue6
            },
            label: {
              color: colorGrid.gray1
            }
          },
          versionStyle:{
            color: colorGrid.gray1
          },
          //styles help & viewalerts buttons
          buttonStyle : {
            buttonStyles : {
              backgroundColor: colorGrid.gray7,
              borderColor: colorGrid.gray4,
              borderBottomLeftRadius: '2px',
              borderBottomRightRadius: '2px',
              borderTopLeftRadius: '2px',
              borderTopRightRadius: '2px'
            },
            labelStyles : {
              color: colorGrid.gray0
            },
            svgStyles : {
              fill: colorGrid.gray0
            },
            hoverButtonStyles : {
              backgroundColor: colorGrid.gray6,
              borderColor: colorGrid.gray3
            },
            hoverLabelStyles: {},
            hoverSvgStyles: {},
            focusButtonStyles: {},
            focusLabelStyles: {},
            focusSvgStyles: {}
          },
          logoutButtonStyle : {
            buttonStyles: {
              backgroundColor: colorGrid.red8,
              borderBottomLeftRadius: '2px',
              borderBottomRightRadius: '2px',
              borderTopLeftRadius: '2px',
              borderTopRightRadius: '2px'
            },
            labelStyles: {
              color: colorGrid.gray0
            },
            hoverButtonStyles: {
              backgroundColor: colorGrid.red6
            },
            svgStyles: {},
            hoverLabelStyles: {},
            hoverSvgStyles: {},
            focusButtonStyles: {},
            focusLabelStyles: {},
            focusSvgStyles: {}
          }
        },

        /******** SOFTPHONE **********/
        softphone : {
          container : {
            backgroundColor: colorGrid.gray8
            //boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.2)',
          },
          alertContainer : {
            backgroundColor: colorGrid.gray8
            //boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.2)',
          },
          callListStyles: {
            callListContainer:{
              //backgroundColor: 'cyan'
              //backgroundColor: 'pink'
            }
          },
          buttonBarStyles: {
            buttonBar: {
              backgroundColor: colorGrid.gray8
              //borderTop: '1px solid #e0e0e0',
            }
          },
          phoneButtonStyles: {
            buttonStyles : {
              backgroundColor: colorGrid.green8,
              borderBottomLeftRadius: '2px',
              borderBottomRightRadius: '2px',
              borderTopLeftRadius: '2px',
              borderTopRightRadius: '2px'
            },
            labelStyles : {
              color: colorGrid.gray0
            },
            hoverButtonStyles: {
              backgroundColor: colorGrid.green6
            }
          },
          vmButtonStyles: {
            buttonStyles: {
              backgroundColor: colorGrid.gray8
            },
            svgStyles: {
              fill: colorGrid.gray0
            }
          },
          badge : {
            badgeOptions: {
              backgroundColor: colorGrid.red8
            }
          },
          callHistoryButtonStyles: {
            buttonStyles: {
              backgroundColor: colorGrid.gray8
            },
            svgStyles: {
              fill: colorGrid.gray0
            }
          },
          hangupButtonStyles: {
            buttonStyles: {
              backgroundColor: colorGrid.red8,
              borderBottom: 'none',
              borderLeft: 'none',
              borderRight: 'none',
              borderTop: 'none',
              borderBottomLeftRadius: '2px',
              borderBottomRightRadius: '2px',
              borderTopLeftRadius: '2px',
              borderTopRightRadius: '2px'
            },
            labelStyles: {
              color: colorGrid.gray0
            },
            hoverButtonStyles: {
              backgroundColor: colorGrid.red6
            }
          },
          cancelButtonStyles: {
            buttonStyles : {
              backgroundColor: colorGrid.gray7,
              borderTop: '1px solid',
              borderRight: '1px solid',
              borderBottom: '1px solid',
              borderLeft: '1px solid',
              borderColor: colorGrid.gray4,
              borderBottomLeftRadius: '2px',
              borderBottomRightRadius: '2px',
              borderTopLeftRadius: '2px',
              borderTopRightRadius: '2px'
            },
            labelStyles : {
              color: colorGrid.gray0
            },
            hoverButtonStyles : {
              backgroundColor: colorGrid.gray5
            }
          },
          blindTransferButtonStyles: {
            buttonStyles : {
              borderBottom: 'none',
              borderLeft: 'none',
              borderRight: 'none',
              borderTop: 'none',
              backgroundColor: colorGrid.red8,
              borderBottomLeftRadius: '2px',
              borderBottomRightRadius: '2px',
              borderTopLeftRadius: '2px',
              borderTopRightRadius: '2px'
            },
            labelStyles : {
              color: colorGrid.gray0
            },
            hoverButtonStyles: {
              backgroundColor: colorGrid.red6
            }
          },
          attendedTransferButtonStyles: {
            buttonStyles : {
              backgroundColor: colorGrid.green8,
              borderBottomLeftRadius: '2px',
              borderBottomRightRadius: '2px',
              borderTopLeftRadius: '2px',
              borderTopRightRadius: '2px'
            },
            svgStyles : {
              fill: colorGrid.gray0
            },
            hoverButtonStyles: {
              backgroundColor: colorGrid.green6
            }
          },
          cancelTransferButtonStyles: {
            buttonStyles : {
              backgroundColor: colorGrid.gray7,
              borderTop: '1px solid',
              borderRight: '1px solid',
              borderBottom: '1px solid',
              borderLeft: '1px solid',
              borderColor: colorGrid.gray4,
              borderBottomLeftRadius: '2px',
              borderBottomRightRadius: '2px',
              borderTopLeftRadius: '2px',
              borderTopRightRadius: '2px'
            },
            labelStyles : {
              color: colorGrid.gray0
            },
            hoverButtonStyles : {
              backgroundColor: colorGrid.gray5
            }
          },
          dtmfHeaderStyles: {
            backgroundColor: '#00111e'
            //color: '#fff',
          }
        },

        /******** UPDATE **********/
        update: {
          windowStyle:{},
          updateComp:{
            buttonStyles: {},
           labelStyles: {}
          },
          buttonBarComp : {
            buttonBar: {}
          },
          postponeComp: {
            buttonStyles: {},
            labelStyles: {}
          },
          header: {
              backgroundColor: colorGrid.gray8
          },
          msgArea:{}
        },
        appmenu : {
          appMenuContainerStyleClosed: {
            backgroundColor: colorGrid.gray9
          },
          appMenuContainerStyleOpen: {
            backgroundColor: colorGrid.gray8
          },
          appMenuDropdownStyle: {
            backgroundColor: colorGrid.gray8,
            color: colorGrid.gray0
          },
          caretStyle : {
            fill : colorGrid.gray0
          },
          appMenuMotionContainerStyle: {},
          contactStatusStyle:{
            contactStatusArea: {},
            offline:{
              statusMsgArea:{},
              iconStyle: {}
            },
            online: {
              statusMsgArea: {},
              iconStyle: {}
            },
            busy: {
              statusMsgArea: {}
            }
          },
          userInfoArea : {
            backgroundColor: colorGrid.gray8,
            borderBottom: colorGrid.gray6,
            color: colorGrid.gray0
          },
          selectMenu : {
            containerStyle: {
              backgroundColor: colorGrid.gray9,
              borderBottom: '1px solid' + colorGrid.gray6,
              borderLeft: '1px solid' + colorGrid.gray6,
              borderRight: '1px solid' + colorGrid.gray6,
              borderTop: '1px solid' + colorGrid.gray6
            },
            containerStyleHover: {
              backgroundColor: colorGrid.gray8
            },
            dropDown: {
              backgroundColor: colorGrid.gray9
            },
            dropDownItem: {
              backgroundColor: colorGrid.gray9
            },
            hoverBackgroundColor: {
              backgroundColor: colorGrid.gray8
            },
            selectStyle: {},
            disabledSelectStyle: {},
            svgContainerStyle:{},
            svgStyles:{
              fill: colorGrid.gray0
            },
            controlStyle:{},
            menuOptionStyle:{},
            alertStyles : {},
            alertSVGStyles : {}
          },
          version: {},
          logoutButton : {
            buttonStyles: {},
            labelStyles: {},
            svgStyles: {},
            hoverButtonStyles: {},
            hoverLabelStyles: {},
            hoverSvgStyles: {},
            focusButtonStyles: {},
            focusLabelStyles: {},
            focusSvgStyles: {}
          },
          settingsButton:{
            buttonStyles: {
              backgroundColor: colorGrid.gray8,
              color: colorGrid.gray0
            },
            labelStyles: {
              color: colorGrid.gray0
            },
            svgStyles: {
              fill: colorGrid.gray0
            },
            hoverButtonStyles: {
              backgroundColor: colorGrid.gray7
            },
            hoverLabelStyles: {},
            hoverSvgStyles: {},
            focusButtonStyles: {},
            focusLabelStyles: {},
            focusSvgStyles: {}
          }
        },
        settingsnav : {
          settingsContainer:{
            //backgroundColor: 'purple'
            backgroundColor: colorGrid.gray8
          },
          headerStyle: {
            background: colorGrid.gray7
          },
          backButton : {
            buttonStyles : {},
            svgStyles : {},
            hoverButtonStyles: {
              backgroundColor: colorGrid.gray5
            },
            focusButtonStyles: {
              backgroundColor: colorGrid.gray5
            }
          },
          settingsNavButtonStyle : {
            settingsButton: {
              backgroundColor: colorGrid.gray9,
              borderBottom: '2px solid' + colorGrid.gray8
              //color: colorGrid.gray2
            },
            settingsButtonHoverFocus: {
              backgroundColor: colorGrid.gray4
            },
            settingsButtonLabel: {
              color: colorGrid.gray2
            },
            settingsButtonLabelHoverFocus: {
              color: colorGrid.gray9
            },
            settingsSvg: {
              fill: colorGrid.gray2
            },
            settingsSvgHoverFocus: {
              color: colorGrid.gray9
            },
            topLabel:{},
            bottomLabel:{}
          }
        },

        /*****SETTINGSCATEGORYPAGE(DARK)*******/
        settingscategory : {
          settingsContainer:{
            backgroundColor: colorGrid.gray9,
            color: colorGrid.gray0
          },
          headerStyle: {
            background: colorGrid.gray7,
            //color: '#F8F9FA',
          },
          backButton : {
            buttonStyles : {
              background: colorGrid.gray7,
            },
            svgStyles : {},
            hoverButtonStyles: {
              background: colorGrid.gray5,
            },
            focusButtonStyles: {
              background: colorGrid.gray5,
            }
          },
          deleteButtonStyles: {
            buttonStyles : {},
            svgStyles : {},
            hoverButtonStyles: {
              backgroundColor: colorGrid.gray5
            },
            focusButtonStyles: {
              backgroundColor: colorGrid.gray5
            }
          },
          renderedCategoryStyle: {
            backgroundColor: colorGrid.gray9
          },
          contactSettingCompStyle: {
            contactContainerStyles : {

            },
            importContactsCompStyle : {
              importContactSettingContainerStyle : {
                backgroundColor: colorGrid.gray9
              },
              importListContainerStyle : {},
              sectionStyle : {},
              sectionTitleStyle : {
                color: colorGrid.gray0
              },
              sectionInstructionStyle : {},
              importBackupContainerStyle : {},
              sampleButtonCompStyle : {
                buttonStyles: {},
                labelStyles: {},
                svgStyles: {},
                hoverButtonStyles: {},
                hoverLabelStyles: {},
                hoverSvgStyles: {},
                focusButtonStyles: {},
                focusLabelStyles: {},
                focusSvgStyles: {}
              },
              backupButtonCompStyle : {
                buttonStyles: {},
                labelStyles: {},
                svgStyles: {},
                hoverButtonStyles: {},
                hoverLabelStyles: {},
                hoverSvgStyles: {},
                focusButtonStyles: {},
                focusLabelStyles: {},
                focusSvgStyles: {}
              },
              importSourceListCompStyle : {
                importSourceListStyle: {},
                importSourceListItemStyle: {},
                importSourceLabelStyle: {},
                logoStyle: {},
                importButtonCompStyle : {
                  buttonStyles: {},
                  labelStyles: {},
                  svgStyles: {},
                  hoverButtonStyles: {},
                  hoverLabelStyles: {},
                  hoverSvgStyles: {},
                  focusButtonStyles: {},
                  focusLabelStyles: {},
                  focusSvgStyles: {}
                },
                importSourceSvgStyle: {},
              }
            }
          },
          notificationSettingStyles : {
            notificationContainerStyles : {
              backgroundColor: colorGrid.gray9,
            },
            notificationTitleStyles : {
              color: colorGrid.gray0,
            },
            notificationDescriptionStyles : {
              color: colorGrid.gray4,
            },
            selectStyles : {
              containerStyle: {
                color: colorGrid.gray9,
              },
              containerStyleHover: {},
              dropDown: {
                color: colorGrid.gray9,
              },
              dropDownItem: {
                color: colorGrid.gray9,
              },
              hoverBackgroundColor: {},
              selectStyle: {
                color: colorGrid.gray9,
              },
              disabledSelectStyle: {
                color: colorGrid.gray9,
              },
              svgContainerStyle:{},
              svgStyles:{},
              controlStyle:{},
              menuOptionStyle:{},
              alertStyles : {},
              alertSVGStyles : {}
            },
            notificationCheckboxStyles : {
              containerStyle: {},
              input: {},
              checkbox: {},
              checkSVG: {},
              checkSVGChecked: {},
              checkboxChecked: {},
              label: {
                color: colorGrid.gray0,
              }
            }
          },
          appearanceSettingStyles : {
            appearanceContainerStyles : {
              backgroundColor: colorGrid.gray9,
            },
            appearanceTitleStyles : {
              color: colorGrid.gray0,
            },
            appearanceDescriptionStyles : {
              color: colorGrid.gray4,
            },
            appearanceCheckboxStyles : {
              containerStyle: {},
              input: {},
              checkbox: {},
              checkSVG: {},
              checkSVGChecked: {},
              checkboxChecked: {},
              label: {
                color: colorGrid.gray0,
              }
            },
            selectStyles : {
              containerStyle: {
                color: colorGrid.gray9
              },
              containerStyleHover: {},
              dropDown: {
                color: colorGrid.gray9
              },
              dropDownItem: {
                color: colorGrid.gray9
              },
              hoverBackgroundColor: {},
              selectStyle: {
                color: colorGrid.gray9
              },
              disabledSelectStyle: {
                color: colorGrid.gray9
              },
              svgContainerStyle:{},
              svgStyles:{},
              controlStyle:{},
              menuOptionStyle:{},
              alertStyles : {},
              alertSVGStyles : {}
            }
          }, // END OF APPEARANCESETTINGSTYLES
          deviceSettingStyles : {
            inputDeviceStyle:{
              borderBottom: "1px solid"+ colorGrid.gray7,
            },
            devicesContainerStyles : {
              backgroundColor: colorGrid.gray9,
            },
            devicesTitleStyles : {
              color: colorGrid.gray0,
            },
            devicesDescriptionStyles : {
              color: colorGrid.gray4,
            },
            selectStyles : {
              containerStyle: {
                color: colorGrid.gray9
              },
              containerStyleHover: {},
              dropDown: {
                color: colorGrid.gray9
              },
              dropDownItem: {
                color: colorGrid.gray9
              },
              hoverBackgroundColor: {},
              selectStyle: {
                color: colorGrid.gray9
              },
              disabledSelectStyle: {
                color: colorGrid.gray9
              },
              svgContainerStyle:{},
              svgStyles:{},
              controlStyle:{},
              menuOptionStyle:{},
              alertStyles : {},
              alertSVGStyles : {}
            }
          },
          troubleshootingSettingStyles : {
            troubleshootingContainerStyles : {
              backgroundColor: colorGrid.gray9,
            },
            troubleshootingTitleStyles : {
              color: colorGrid.gray0,
            },
            troubleshootingDescriptionStyles : {
              color: colorGrid.gray4,
            },
            troubleshootingCheckboxStyles : {
              containerStyle: {},
              input: {},
              checkbox: {},
              checkSVG: {},
              checkSVGChecked: {},
              checkboxChecked: {},
              label: {
                color: colorGrid.gray0
              }
            }
          },
        }, // END OF SETTINGSCATEGORY(DARK)

        /*****CONTACTDETAILSCARD(DARK)*******/
        contactdetailscard : {
          // list zero state comp style working in route
          listZeroStateStyle : {
            zeroStateStyle: {
              backgroundColor: colorGrid.gray9,
              color: colorGrid.gray0
            },
             zeroSateText: {
               color: colorGrid.gray0
             },
             //becasue we do not have the corect svg as of 4/4 this style is likely to change
             zeroStateSVG: {},
             zeroStateButtonContainer:{},
             zeroStateButtonStyle:{
                buttonStyles:{},
               labelStyles: {},
              zeroStateDescription : {}
             }
          },
          panelListStyle : {
            panelList : {
              backgroundColor: colorGrid.gray9,
              color: colorGrid.gray0
            },
            cardPanelOverrideStyle : {
              containerStyle : {
                backgroundColor: colorGrid.gray9,
                color: colorGrid.gray0
              },
              headerStyle : {
                backgroundColor : colorGrid.gray9
              },
              //removes inherent ul styles
              ul: {},
              li: {},
              panelItemStyle : {
                backgroundColor: colorGrid.gray8,
                color: colorGrid.gray0
              },
            },


          },
          contactCardArea: {
            backgroundColor: colorGrid.gray9
          },
          // cardDetailsOverride style working in route
          cardDetailsOverride: {
            cardDetailsDefault: {},
            cardDetailsGravatar: {},
            nameArea: {},
            topCardArea: {},
            btnWrapper: {},
            editBtn: {
              buttonStyles: {},
              labelStyles: {},
              svgStyles: {}
            },
            nameCompanyArea: {},
            entityName: {},
            entityCompanyNameStyles: {},
            deleteBtn: {
              buttonStyles: {},
              labelStyles: {},
              svgStyles: {}
            }
          },
          contactDetailsFormCompStyle : {
            formScreenStyle : {
              backgroundColor: colorGrid.gray9
            },
            formScreenHeaderStyle : {
              backgroundColor: colorGrid.gray7
            },
            formScreenHeaderCenterStyle : {
              backgroundColor: colorGrid.gray7
            },
            formErrorBarStyle : {},
            labelStyle : {},
            phoneTypeLabelStyle : {
              backgroundColor: colorGrid.gray9
            },
            phoneInputLabelStyle : {
              backgroundColor: colorGrid.gray9
            },
            phoneRadioLabelStyle : {
              backgroundColor: colorGrid.gray9
            },
            contactDetailsFormStyle : {
              backgroundColor: colorGrid.gray9
            },
            fieldsetStyle : {
              backgroundColor: colorGrid.gray9,
              color: colorGrid.gray1
            },
            legendStyle : {
              backgroundColor: colorGrid.gray9,
              color: colorGrid.gray1
            },
            labelParagraphStyle : {
              color: colorGrid.gray1
            },
            formScreenHeaderParagraphStyle : {},
            phoneNumberULStyle : {},
            phoneNumberLIStyle : {},
            phoneNumberLITopStyle : {},
            phoneNumberLIBottomStyle : {
              backgroundColor: colorGrid.gray9
            },
            deletePhoneNumberButtonCompStyle : {
              buttonStyles: {},
              labelStyles: {},
              svgStyles: {
                fill: colorGrid.gray0
              },
              hoverButtonStyles: {},
              hoverLabelStyles: {},
              hoverSvgStyles: {},
              focusButtonStyles: {},
              focusLabelStyles: {},
              focusSvgStyles: {}
            },
            // Not theming this button at this time, so removing component style properties
            addPhoneNumberButtonCompStyle : {},
            inputFieldCompStyle : {
              alertSvg: {},
              alertSvgArea: {},
              disabledInput: {},
              disabledInputNoSVG: {},
              errorText: {},
              inputAlert: {},
              //inputField: {},
              inputFieldNoSVG: {
                backgroundColor: colorGrid.gray8,
                color: colorGrid.gray2
              },
              //inputFieldWithError: {},
              inputFieldWithErrorNoSVG: {
                backgroundColor: colorGrid.gray8,
                color: colorGrid.gray2
              },
              //inputFieldWithHover: {},
              inputFieldWithHoverNoSVG: {
                backgroundColor: colorGrid.gray8,
                color: colorGrid.gray2
              },
              //inputFieldWithFocus: {},
              inputFieldWithFocusNoSVG: {
                backgroundColor: colorGrid.gray8,
                color: colorGrid.gray2
              },
              inputComponent: {},
              inputContainer: {},
              showHide: {},
              showHideWithError: {},
              svgArea: {},
              noSVGArea: {},
              svgAreaWithError: {},
              svgAreaWithFocus: {},
              svgAreaWithHover: {},
              svgStyle: {},
              svgStyleChange: {},
              svgStyleWithHover: {},
              noSvgStyle: {}
            },
            selectCompStyle : {
              containerStyle: {
                backgroundColor: colorGrid.gray8
              },
              containerStyleHover: {
                backgroundColor: colorGrid.gray7
              },
              dropDown: {
                backgroundColor: colorGrid.gray8
              },
              dropDownItem: {
                backgroundColor: colorGrid.gray8
              },
              hoverBackgroundColor: {
                backgroundColor: colorGrid.gray7
              },
              selectStyle: {},
              disabledSelectStyle: {},
              svgContainerStyle:{},
              svgStyles:{},
              controlStyle:{},
              menuOptionStyle:{
                backgroundColor: colorGrid.gray9
              },
              alertStyles : {},
              alertSVGStyles : {}
            },
            saveButtonCompStyle : {
              buttonStyles: {},
              labelStyles: {},
              svgStyles: {},
              hoverButtonStyles: {},
              hoverLabelStyles: {},
              hoverSvgStyles: {},
              focusButtonStyles: {},
              focusLabelStyles: {},
              focusSvgStyles: {}
            },
            cancelButtonCompStyle : {
              buttonStyles: {
                border : '1px solid'+ colorGrid.gray5
              },
              labelStyles: {},
              svgStyles: {},
              hoverButtonStyles: {
                backgroundColor: colorGrid.gray5
              },
              hoverLabelStyles: {},
              hoverSvgStyles: {},
              focusButtonStyles: {},
              focusLabelStyles: {},
              focusSvgStyles: {}
            },
            backButtonCompStyle: {
              buttonStyles: {
                color: colorGrid.gray9
              },
              labelStyles: {
                color: colorGrid.gray9
              },
              svgStyles: {},
              hoverButtonStyles: {
                backgroundColor: colorGrid.gray5
              },
              hoverLabelStyles: {
                color: colorGrid.gray9
              },
              hoverSvgStyles: {},
              focusButtonStyles: {
                backgroundColor: colorGrid.gray5
              },
              focusLabelStyles: {},
              focusSvgStyles: {}
            },
          },
          // modal override styles
          modalContentOverrideStyle : {
            modalContentStyle : {
              backgroundColor: colorGrid.gray9,
              //boxShadow : '0 6px 16px 0 rgba(3, 3, 4, 0.26)',
            },

            headerTextStyle : {
              color: colorGrid.gray0,
            },

            descriptionTextStyle : {
              //color: colorGrid.gray5,
            },

            buttonContainerStyle : {},

            cancelButtonStyle : {
              buttonStyles : {
                // backgroundColor: colorGrid.gray1,
                //border: '1px solid'+ colorGrid.gray3,
              },
              labelStyles : {
                //color: colorGrid.gray9
              }
             },

             deleteButtonStyle : {
              buttonStyles : {
                // backgroundColor: colorGrid.red7,
              },
              labelStyles : {
                // color: colorGrid.gray1
              }
             },
          }
        }, // end of contact details

        /*****CONTACTDETAILSROUTE(DARK)*******/

        contactdetailsroute: {
          contactDetailsContainerStyles : {
            backgroundColor: colorGrid.gray9
          }
        },// END OF CONTACTDETAILSROUTE(DARK)

        /*****CONTACTLIST(DARK)*******/
        contactlist: {

          searchFilterStyle: {
            searchSvgFocusStyle:{
              fill: colorGrid.blue8
            },
            searchSvgStyle:{
              fill: colorGrid.gray9
            },
            searchFilterInputStyle:{
              backgroundColor: colorGrid.gray8,
              color: colorGrid.gray2
            },
            searchFilterInputHoverStyle: {
              backgroundColor: colorGrid.gray7
            },
            searchFilterInputFocusStyle: {
              borderBottom:  '2px solid '+colorGrid.blue8,
              borderLeft:  '2px solid '+colorGrid.blue8,
              borderRight:  '2px solid '+colorGrid.blue8,
              borderTop: '2px solid '+colorGrid.blue8,
              color: colorGrid.gray2
            },
            removeSvgStyle: {
              fill: colorGrid.gray2
            }
          },
          addButton:{
            hoverButtonStyles: {
              backgroundColor: colorGrid.green9
            }
          },
          mainGroupArea: {
            backgroundColor: colorGrid.gray8
          },
          alphaSearchBar:{
            backgroundColor: colorGrid.gray8
          },
          topContainer: {
            backgroundColor: colorGrid.gray8
          },
          divider:{
            backgroundColor: colorGrid.gray8,
            color: colorGrid.gray0
          },
          groupLI: {
            backgroundColor: colorGrid.gray9
          },
          lazyContainer:{
            backgroundColor: colorGrid.gray9,
            boxShadow: 'inset 0 -1px 0 0 '+colorGrid.gray6,
            height: '100%'
          },
          lazyAvatarPlaceholder:{
            backgroundColor: colorGrid.gray7
          },
          lazyNamePlaceholder: {
            backgroundColor: colorGrid.gray7
          },
          contactListItemObj:{
            avatarCompStyle: {
              containerStyle : {
                border: 'solid 1px '+colorGrid.gray6
              }
            },
            contactListItem: {
              backgroundColor: colorGrid.gray9,
              boxShadow: 'inset 0 -1px 0 0 '+colorGrid.gray6
            },
            contactListItemHover: {
              backgroundColor: colorGrid.gray7,
              boxShadow: 'inset 0 -1px 0 0 '+colorGrid.gray4
            },
            contactName:{
              color: colorGrid.gray0
            },
            actionSvgStyle:{
              fill: colorGrid.gray0
            }
          },
          zerostateStyle: {
            backgroundColor: colorGrid.gray9
          },
          noContactsStyle: {
            color: colorGrid.gray0
          },
          importContactStyle: {
            color: colorGrid.gray0
          },
          contactDescriptionStyle: {
            color: colorGrid.gray0
          },
          importButtonStyle: {
            buttonStyles: {
              backgroundColor: colorGrid.purple9
            }
          },
          addButtonStyle: {
            buttonStyles: {
              backgroundColor: colorGrid.green9
            }
          }
        },// END OF CONTACTLIST(DARK)
      },

  // ******************************
  // ****        Custom        ****
  // ******************************

  Custom: {

    /******** ALERT ITEM *********/
    alertitem : {
      alertItemStyles : {

      },
      detailTextStyle:{
        color: colorGrid.gray0
      },
      errorBorderStyles : {
        border: '4px solid ' + colorGrid.red9
      },
      warnBorderStyles : {
        border: '4px solid ' + colorGrid.orange9
      },
      infoBorderStyles : {
        border: '4px solid ' + colorGrid.green9
      },
      errorDetailStyle:{
        backgroundColor: colorGrid.red9
      },
      warnDetailStyle:{
        backgroundColor: colorGrid.orange9
      },
      infoDetailStyle:{
        backgroundColor: colorGrid.green9
      },
      errorBackgroundStyles : {
        backgroundColor: colorGrid.red8
      },
      warnBackgroundStyles : {
        backgroundColor: colorGrid.orange8
      },
      infoBackgroundStyles : {
        backgroundColor: colorGrid.green8
      },
      headingStyles: {
        //color: colorGrid.gray0
      },
      alertSvgStyles : {
        fill: colorGrid.gray0
      },
      closeSvgStyles : {
        //fill: '#8c0112'
      },
      alertDetailStyle : {
        backgroundColor: colorGrid.gray0
      },
      errorCloseSvgStyles : {
        fill: colorGrid.red2
      },
      warnCloseSvgStyles : {
        fill: colorGrid.orange2
      },
      infoCloseSvgStyles : {
        fill: colorGrid.green2
      }
    },

    /********* ALERT LOG *********/
    alertlog : {
      headerArea : {
        //backgroundColor: 'red'
        //backgroundColor: '#e7edf1',
      },
      listArea : {
        //backgroundColor: '#f2f5f7',
      },
      dateSeparator : {
        //backgroundColor: '#f2f5f7',
        //color: '#121212',
        //boxShadow: 'inset 0 1px 0 0 rgba(13, 91, 155, 0.1), inset 0 -1px 0 0 rgba(13, 91, 155, 0.1)'
      },
      noAlerts : {
        //boxShadow: 'inset 0 1px 0 0 rgba(13, 91, 155, 0.1)',
      }
    },

    /******* CALL CONTROLS *******/
    callcontrols : {
      callControlsWrapStyles: {
        backgroundColor: colorGrid.gray0
      },
      hoverStyle: {
        hoverButtonStyles: {
          backgroundColor: colorGrid.gray2
          //border: '2px solid',
          //borderColor: colorGrid.gray5
        },
        hoverLabelStyles: {
          //color: colorGrid.gray0
        },
        hoverSvgStyles: {
          //fill: colorGrid.gray0
        }
      },
      focusStyle: {
        focusButtonStyles: {
          backgroundColor: colorGrid.gray9
          //border: '2px solid #efefef'
        },

        focusLabelStyles: {
          color: colorGrid.gray0
        },

        focusSvgStyles: {
          fill: colorGrid.gray0
        }
      },
      // area that contains top two button bars
      topContainer: {
        background: colorGrid.gray0
      },
      audioControlBtn: {
        buttonStyles: {  },
        labelStyles: {},
        svgStyles: {}
      },
      isMutedHeldButtons: {
        buttonStyles: {
          //border: 'solid 2px #d0021b',
          backgroundColor: colorGrid.gray9
        },
        labelStyles: {
          color: colorGrid.gray0
        },
        svgStyles: {
          fill: colorGrid.gray0
        }
      },
      genericButton: {
        svgStyles: {
          //fill: '#121212',
        }
      },
      // area that contains bottom buttonbar
      bottomContainer: {
        //borderTop: '1px solid #e0e0e0',
      },
      hangupButton: {
        buttonStyles: {
          backgroundColor: colorGrid.red8,
          border: 'none',
          borderRadius: '2px'
        },
        labelStyles: {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.red6
        }
      },
      transferButton: {
        buttonStyles : {
          backgroundColor: colorGrid.green8,
          borderRadius: '2px'
        },
        labelStyles : {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.green6
        }
      },
      disabledByAttendedTransfer: {
        buttonStyles: {},
        labelStyles: {},
        svgStyles: {}
      },
      audioControlCompStyles : {
        audioControlComponent: {},
        audioSettingArea: {},
        buttonBarArea: {},
        controls: {},
        heading: {},
        section: {},
        selection: {},
        slider: {},
        buttonBarCompStyle: {
          buttonBar: {}
        },
        saveBtnCompStyle: {
          buttonStyles : {
            backgroundColor: colorGrid.green8,
            borderTopLeftRadius: '2px',
            borderTopRightRadius: '2px',
            borderBottomLeftRadius: '2px',
            borderBottomRightRadius: '2px'
          },
          labelStyles : {
            color: colorGrid.gray0
          },
          hoverButtonStyles: {
            backgroundColor: colorGrid.green6
          }
        },
        cancelBtnCompStyle: {
          buttonStyles : {
            backgroundColor: colorGrid.gray0,
            borderTop: '1px solid',
            borderRight: '1px solid',
            borderBottom: '1px solid',
            borderLeft: '1px solid',
            borderColor: colorGrid.gray3
          },
          labelStyles : {
            color: colorGrid.gray9
          },
          hoverButtonStyles : {
            backgroundColor: colorGrid.gray2
          }
        }
      }
    },

    /******* CALL DETAIL *********/
    calldetail : {
      selectedCallDetailItem:{
        //backgroundColor: '#003a66',
        //boxShadow: 'inset 0 -1px 0 0 rgba(0, 0, 0, 0.5), inset 0 1px 0 0 rgba(0, 0, 0, 0.5)',
        //color: '#fff',
      },
      unselectedCallDetailItem:{
        //backgroundColor: '#0b5087',
        //boxShadow: 'inset 0 -1px 0 0 rgba(0, 0, 0, 0.5), inset 0 1px 0 0 rgba(0, 0, 0, 0.5)',
        //color: '#fff',
      },
      callDirectionSVG: {
        //fill: '#fff'
      },
      statusCompStyle: {
        statusSvgStyle:{
          //fill: '#fff'
        }
      }
    },

    /******* CALL HISTORY ********/
    callhistory : {
      callHistoryContainer:{
        //backgroundColor: '#fff'
      },
      header: {
        //backgroundColor: '#e7edf1',
        //boxShadow: 'inset 0 -1px 0 0 rgba(13, 91, 155, 0.1)',
      },
      noCallHistory: {
        //backgroundColor: '#f2f5f7',
      },
      dateHeading: {
        //background: '#f2f5f7',
        //boxShadow: 'inset 0 -1px 0 0 rgba(13, 91, 155, 0.1)',
      },
      backBtn: {
        buttonStyles: {
          //backgroundColor: '#e7edf1',
          //border: 'none',
        },
        labelStyles: {
          //color: '#121212',
        },
        svgStyles: {
          //fill: '#000'
        }
      },
      clearBtn: {
        buttonStyles: {
          //backgroundColor: '#e7edf1',
          //border: 'none',
        },
        labelStyles: {
          //color: '#121212',
        },
        svgStyles: {
          //fill: '#000'
        }
      },
      callDetailComp:{
        unselectedCallDetailItem:{
          //backgroundColor: '#fff',
          //color: '#1a1a1a',
          //boxShadow: 'inset 0 -1px 0 0 #e8eef3'
        },
        callDirectionSVG: {
          //fill: '#979797',
        },
        statusArea: {
          //color: '#d0021b'
        },
        infoArea: {
          //color: '#979797'
        }
      }
    },

    /******** CALL LIST **********/
    calllist : {
      callListContainer:{
        //backgroundColor: 'red'
        //backgroundColor: '#0d5c9b',
        //color: '#fff',
      },
      svg: {
        //fill: '#fff',
      },
      // styles callDetailItem
      listItem: {
        //backgroundColor: 'pink'
        //backgroundColor: 'green'
      }
    },

    /******* DIALING INPUT *******/
    dialinginput : {
      dialingInputFocused : {
        //backgroundColor: '#fff',
        //boxShadow: 'inset 0 0 5px 0 #4ab7e2',
        //color: '#121212',

      },
      dialingInputUnfocused : {
        //backgroundColor: '#003a66',
        //boxShadow: 'none',
        //color: '#fff',
      },
      inputFocused : {
        //backgroundColor: '#fff',
      },
      inputUnfocused : {
        //backgroundColor: '#003a66',
      },
      placeholderColor : {
        //color: colorGrid.gray1
      }
    },

    /********** HEADER ***********/
    header : {
      headerContainer : {
        // backgroundColor: colorGrid.gray0,
        // borderBottom: '1px solid ' + colorGrid.gray0
      },
      btnOpen: {
        buttonStyles: {
          // backgroundColor: colorGrid.gray0
        },
        svgStyles: {
          // fill: colorGrid.gray9
        }
      },
      btnClosed: {
        buttonStyles: {
          // backgroundColor: colorGrid.gray8
        },
        svgStyles: {
          // fill: colorGrid.gray0
        }
      },
      connectedSvgStyle : {
        //fill: '#7ed321'
      },
      offlineSvgStyle : {
        //fill: '#ffffff'
      }
    },

    /****** INCOMING CALL ********/
    incomingcall : {
      acceptComp:{
          buttonStyles : {
            border: 'none',
            backgroundColor: colorGrid.green8,
            borderRadius: '2px'
          },
          labelStyles : {
            color: colorGrid.gray0
          },
          hoverButtonStyles: {
            backgroundColor: colorGrid.green6
          }
      },
      callDetailComp: {
        unselectedCallDetailItem:{
          backgroundColor: colorGrid.gray1,
          color: colorGrid.gray9
        }
      },
      declineComp: {
        buttonStyles : {
          border: 'none',
          backgroundColor: colorGrid.red8,
          borderRadius: '2px'
        },
        labelStyles : {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.red6
        }
      },
      header: {
        backgroundColor: colorGrid.gray0,
        color: colorGrid.gray9
      },
      incomingCallContainer:{
        backgroundColor: colorGrid.gray0
      },
      voicemailComp: {
        buttonStyles : {
          backgroundColor: colorGrid.gray0,
          border: '1px solid',
          borderColor: colorGrid.gray3
        },
        labelStyles : {
          color: colorGrid.gray9
        },
        hoverButtonStyles : {
          backgroundColor: colorGrid.gray2
        }
      }
    },

    /********** KEYPAD ***********/
    keypad : {
      wrapper: {
        backgroundColor: colorGrid.gray0
      },
      KeyItemContainer : {
        backgroundColor: colorGrid.gray0
      },
      keypadItem: {
        container: {
          backgroundColor: colorGrid.gray0,
          borderTop: '1px solid transparent',
          borderRight: '1px solid transparent',
          borderBottom: '1px solid transparent',
          borderLeft: '1px solid transparent',
          color: colorGrid.gray9,
          ':hover': {
            // color: colorGrid.gray9,
            backgroundColor: colorGrid.gray2,
            borderTop: '1px solid',
            borderRight: '1px solid',
            borderBottom: '1px solid',
            borderLeft: '1px solid',
            borderColor: colorGrid.gray5
          },
          ':active': {
            color: colorGrid.blue6,
            backgroundColor: colorGrid.gray0,
            borderTop: '1px solid',
            borderRight: '1px solid',
            borderBottom: '1px solid',
            borderLeft: '1px solid',
            borderColor: colorGrid.blue6
          }
        },
        textArea : {
          color: colorGrid.gray9
        },
        keyValue: {
          color: colorGrid.gray9
          // fontSize: '16px'
        },
        keyString: {
          color: colorGrid.gray6
          // fontSize: '12px',
        }
      }
    },

    /********** LOGIN ************/
      login : {
        //styles forgot password block
        forgot : {
          loginBlockForgot : {
            backgroundColor: colorGrid.gray8
          },
          textAreaStyle: {
            color: colorGrid.gray0
          },
        //styles input field
          labelledInputForgotStyle : {
            inputField: {
              backgroundColor: colorGrid.gray7,
              borderBottom: '1px solid' + colorGrid.gray3,
              borderLeft: 'none',
              borderRight: '1px solid' + colorGrid.gray3,
              borderTop: '1px solid' + colorGrid.gray3,
              color: colorGrid.gray0
            },
            inputFieldWithError: {
              backgroundColor: colorGrid.gray7,
              borderBottom: '2px solid' + colorGrid.red8,
              borderLeft: 'none',
              borderRight: '2px solid' + colorGrid.red8,
              borderTop: '2px solid' + colorGrid.red8
            },
            inputFieldWithFocus: {
              backgroundColor : colorGrid.gray7,
              borderTop: 'solid 2px' + colorGrid.blue6,
              borderLeft: 'none',
              borderBottom: 'solid 2px' + colorGrid.blue6,
              borderRight: 'solid 2px' + colorGrid.blue6,
              color: colorGrid.gray0
            },
            inputFieldWithHover: {
              backgroundColor: colorGrid.gray6,
              borderBottom: '1px solid' + colorGrid.gray5,
              borderLeft: 'none',
              borderRight: '1px solid' + colorGrid.gray5,
              borderTop: '1px solid' + colorGrid.gray5,
              color: colorGrid.gray0
            },
            showHide: {},
            svgArea: {
              backgroundColor: colorGrid.gray7,
              border: '1px solid' + colorGrid.gray3
            },
            svgAreaWithHover: {
              backgroundColor: colorGrid.gray6,
              border: '1px solid' + colorGrid.gray5
            },
            svgStyle: {
              // fill: colorGrid.gray0
            },
            svgStyleWithHover: {
              // fill: colorGrid.gray0
            },
            hintStyle: {
              // color: colorGrid.gray6
            },
            hintWithFocusStyle: {
              // color: colorGrid.blue6
            },
            hintWithErrorStyle: {
              // color: colorGrid.red8
            },
            inputLabelStyle: {
              // color: colorGrid.gray0
            }
          },
         //styles button area
          buttonAreaForgot: {},
        //styles cancel button
          cancelButtonStyle : {
            buttonStyles: {
              // backgroundColor: colorGrid.gray0,
              // border: 'solid 1px' + colorGrid.gray3
            },
            labelStyles: {
              // color: colorGrid.gray9
            },
            hoverButtonStyles: {
              // backgroundColor: colorGrid.gray2,
              // border: 'solid 1px' + colorGrid.gray5
            },
            focusButtonStyles: {
              // backgroundColor: colorGrid.gray2
            }
          },
           //styles reset password button
          resetButtonStyle : {
            buttonStyles: {
              // backgroundColor: colorGrid.green8
            },
            labelStyles: {
              // color: colorGrid.gray0
            },
            hoverButtonStyles: {
              // backgroundColor: colorGrid.green6
            },
            focusButtonStyles: {
              // backgroundColor: colorGrid.green6
            }
          }
        }, //end forgot password block
        login: {},
        loginForm: {
          loginBlockStyle: {
            // backgroundColor: colorGrid.gray8
          },
          //styles top labelled input field
          labelledInputEmailStyle : {
            inputField: {
              // backgroundColor: colorGrid.gray7,
              // borderBottom: '1px solid' + colorGrid.gray3,
              // borderLeft: 'none',
              // borderRight: '1px solid' + colorGrid.gray3,
              // borderTop: '1px solid' + colorGrid.gray3,
              // color: colorGrid.gray0
            },
            inputFieldWithError: {
              // backgroundColor: colorGrid.gray7,
              // borderBottom: '2px solid' + colorGrid.red8,
              // borderLeft: 'none',
              // borderRight: '2px solid' + colorGrid.red8,
              // borderTop: '2px solid' + colorGrid.red8
            },
            inputFieldWithHover: {
              // backgroundColor: colorGrid.gray6,
              // borderBottom: '1px solid' + colorGrid.gray5,
              // borderLeft: 'none',
              // borderRight: '1px solid' + colorGrid.gray5,
              // borderTop: '1px solid' + colorGrid.gray5,
              // color: colorGrid.gray0
            },
            showHide: {},
            svgArea: {
              // backgroundColor: colorGrid.gray7,
              // border: '1px solid' + colorGrid.gray3
            },
            svgAreaWithHover: {
              // backgroundColor: colorGrid.gray6,
              // border: '1px solid' + colorGrid.gray5
            },
            svgStyle: {
              // fill: colorGrid.gray0
            },
            svgStyleWithHover: {
              // fill: colorGrid.gray0
            },
            hintStyle: {
              // color: colorGrid.gray6
            },
            hintWithFocusStyle: {
              // color: colorGrid.blue6
            },
            hintWithErrorStyle: {
              // color: colorGrid.red8
            },
            inputLabelStyle: {
              // color: colorGrid.gray0
            }
          },
          //styles password input field
          labelledInputPasswordStyle : {
            inputField: {
              // backgroundColor: colorGrid.gray7,
              // borderBottom: '1px solid' + colorGrid.gray3,
              // borderLeft: 'none',
              // borderRight: '1px solid' + colorGrid.gray3,
              // borderTop: '1px solid' + colorGrid.gray3,
              // color: colorGrid.gray0
            },
            inputFieldWithError: {
              // backgroundColor: colorGrid.gray7,
              // borderBottom: '2px solid' + colorGrid.red8,
              // borderLeft: 'none',
              // borderRight: '2px solid' + colorGrid.red8,
              // borderTop: '2px solid' + colorGrid.red8
            },
            inputFieldWithHover: {
              // backgroundColor: colorGrid.gray6,
              // borderBottom: '1px solid' + colorGrid.gray5,
              // borderLeft: 'none',
              // borderRight: '1px solid' + colorGrid.gray5,
              // borderTop: '1px solid' + colorGrid.gray5,
              // color: colorGrid.gray0
            },
            showHide: {
              // color: colorGrid.gray1
            },
            svgArea: {
              // backgroundColor: colorGrid.gray7,
              // border: '1px solid' + colorGrid.gray3
            },
            svgAreaWithHover: {
              // backgroundColor: colorGrid.gray6,
              // border: '1px solid' + colorGrid.gray5
            },
            svgStyle: {
              // fill: colorGrid.gray0
            },
            svgStyleWithHover: {
              // fill: colorGrid.gray0
            },
            hintStyle: {
              // color: colorGrid.gray6
            },
            hintWithFocusStyle: {
              // color: colorGrid.blue6
            },
            hintWithErrorStyle: {
              // color: colorGrid.red8
            },
            inputLabelStyle: {
              // color: colorGrid.gray0
            }
          },
          // area that contains checkbox and forgot password
          linkWrapper: {},
           //styles checkbox/link area
          checkboxForgotPWAreaStyle: {},
          //styles the checkbox
          checkboxStyle: {
            checkboxChecked: {
              // backgroundColor: colorGrid.blue6
            },
            checkbox: {
              // backgroundColor: colorGrid.gray7
            },
            label: {
              // color: colorGrid.gray0
            }
          },
          //styles forgot password button
          forgotButtonBottomStyle: {
            // color: colorGrid.blue6
          },
           //styles forgot password button
          forgotButtonRightStyle: {
            // color: colorGrid.blue6
          },
          // styles button area
          buttonArea : {},
          //styles sign in button
          buttonStyle : {
            buttonStyles: {
              // backgroundColor: colorGrid.green8
            },
            labelStyles: {
              // color: colorGrid.gray0
            },
            hoverButtonStyles: {
              // backgroundColor: colorGrid.green6
            },
            focusButtonStyles: {
              // backgroundColor: colorGrid.green6
            }
          }
        }, //end login block
        //styles reset block
        reset : {
          loginBlockReset: {
            // backgroundColor: colorGrid.gray8
          },
          textAreaResetStyle: {
            //color: colorGrid.gray0
          },
          //styles top password input field
          inputPasswordResetStyle : {
            inputField: {
              // backgroundColor: colorGrid.gray7,
              // borderBottom: '1px solid' + colorGrid.gray3,
              // borderLeft: 'none',
              // borderRight: '1px solid' + colorGrid.gray3,
              // borderTop: '1px solid' + colorGrid.gray3,
              // color: colorGrid.gray0
            },
            inputFieldWithError: {
              // backgroundColor: colorGrid.gray7,
              // borderBottom: '2px solid' + colorGrid.red8,
              // borderLeft: 'none',
              // borderRight: '2px solid' + colorGrid.red8,
              // borderTop: '2px solid' + colorGrid.red8
            },
            inputFieldWithHover: {
              // backgroundColor: colorGrid.gray6,
              // borderBottom: '1px solid' + colorGrid.gray5,
              // borderLeft: 'none',
              // borderRight: '1px solid' + colorGrid.gray5,
              // borderTop: '1px solid' + colorGrid.gray5,
              // color: colorGrid.gray0
            },
            showHide: {
              // color: colorGrid.gray1
            },
            svgArea: {
              // backgroundColor: colorGrid.gray7,
              // border: '1px solid' + colorGrid.gray3
            },
            svgAreaWithHover: {
              // backgroundColor: colorGrid.gray6,
              // border: '1px solid' + colorGrid.gray5
            },
            svgStyle: {
              // fill: colorGrid.gray0
            },
            svgStyleWithHover: {
              // fill: colorGrid.gray0
            },
            hintStyle: {
              // color: colorGrid.gray6
            },
            hintWithFocusStyle: {
              // color: colorGrid.blue6
            },
            hintWithErrorStyle: {
              // color: colorGrid.red8
            },
            inputLabelStyle: {
              // color: colorGrid.gray0
            }
          },
          inputBottomPasswordStyle : {
            labelledInputComponentStyle: {},
            inputField: {
              // backgroundColor: colorGrid.gray7,
              // borderBottom: '1px solid' + colorGrid.gray3,
              // borderLeft: 'none',
              // borderRight: '1px solid' + colorGrid.gray3,
              // borderTop: '1px solid' + colorGrid.gray3,
              // color: colorGrid.gray0
            },
            inputFieldWithError: {
              // backgroundColor: colorGrid.gray7,
              // borderBottom: '2px solid' + colorGrid.red8,
              // borderLeft: 'none',
              // borderRight: '2px solid' + colorGrid.red8,
              // borderTop: '2px solid' + colorGrid.red8
            },
            inputFieldWithHover: {
              // backgroundColor: colorGrid.gray6,
              // borderBottom: '1px solid' + colorGrid.gray5,
              // borderLeft: 'none',
              // borderRight: '1px solid' + colorGrid.gray5,
              // borderTop: '1px solid' + colorGrid.gray5,
              // color: colorGrid.gray0
            },
            showHide: {
              // color: colorGrid.gray1
            },
            svgArea: {
              // backgroundColor: colorGrid.gray7,
              // border: '1px solid' + colorGrid.gray3
            },
            svgAreaWithHover: {
              // backgroundColor: colorGrid.gray6,
              // border: '1px solid' + colorGrid.gray5
            },
            svgStyle: {
              // fill: colorGrid.gray0
            },
            svgStyleWithHover: {
              // fill: colorGrid.gray0
            },
            hintStyle: {
              // color: colorGrid.gray6
            },
            hintWithFocusStyle: {
              // color: colorGrid.blue6
            },
            hintWithErrorStyle: {
              // color: colorGrid.red8
            },
            inputLabelStyle: {
              // color: colorGrid.gray0
            }
          },
           //styles button area
          buttonAreaReset: {},
           //styles cancel button
          notNowButtonStyle : {
            buttonStyles: {
              // backgroundColor: colorGrid.gray0,
              // border: 'solid 1px' + colorGrid.gray3
            },
            labelStyles: {
              // color: colorGrid.gray9
            },
            hoverButtonStyles: {
              // backgroundColor: colorGrid.gray2,
              // border: 'solid 1px' + colorGrid.gray5
            },
            focusButtonStyles: {
              // backgroundColor: colorGrid.gray2
            }
          },
           //styles Change Password button
          changePwdButtonStyle : {
            buttonStyles: {
              // backgroundColor: colorGrid.green8
            },
            labelStyles: {
              // color: colorGrid.gray0
            },
            hoverButtonStyles: {
              // backgroundColor: colorGrid.green6
            },
            focusButtonStyles: {
              // backgroundColor: colorGrid.green6
            }
          }
        }
      },

    /******** SETTINGS ***********/
    settings : {
      container : {
        //backgroundColor: '#f2f5f7',
        //boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.2)',
      },
      selectMenuStyle : {
        containerStyle :{
          //border: '1px solid #dedede'
        },
        dropDown : {
          //borderBottom: '1px solid #dedede',
          //borderLeft: '1px solid #dedede',
          //borderRight: '1px solid #dedede'
        },
        controlStyle : {
          //backgroundColor : 'white'
        }
      },
      versionStyle:{
        color: colorGrid.gray9
      },
      //styles help & viewalerts buttons
      buttonStyle : {
        buttonStyles : {
          backgroundColor: colorGrid.gray0,
          borderTop: '1px solid',
          borderRight: '1px solid',
          borderBottom: '1px solid',
          borderLeft: '1px solid',
          borderColor: colorGrid.gray3,
          borderRadius: '2px'
        },
        labelStyles : {
          color: colorGrid.gray9
        },
        svgStyles : {
          fill: colorGrid.gray9
        },
        hoverButtonStyles : {
          backgroundColor: colorGrid.gray2
        },
        hoverLabelStyles: {},
        hoverSvgStyles: {},
        focusButtonStyles: {},
        focusLabelStyles: {},
        focusSvgStyles: {}
      },
      logoutButtonStyle : {
        buttonStyles: {
          backgroundColor: colorGrid.red8,
          borderRadius: '2px'
        },
        labelStyles: {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.red6
        },
        svgStyles: {},
        hoverLabelStyles: {},
        hoverSvgStyles: {},
        focusButtonStyles: {},
        focusLabelStyles: {},
        focusSvgStyles: {}
      }
    },

    /******** SOFTPHONE **********/
    softphone : {
      container : {
        //backgroundColor: '#f2f5f7',
        //boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.2)',
      },
      alertContainer : {
        //backgroundColor: '#f2f5f7',
        //boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.2)',
      },
      callListStyles: {
        callListContainer:{
          //backgroundColor: 'cyan'
          //backgroundColor: 'pink'
        }
      },
      buttonBarStyles: {
        buttonBar: {
          //backgroundColor: '#fff',
          //borderTop: '1px solid #e0e0e0',
        }
      },
      phoneButtonStyles: {
        buttonStyles: {
          //backgroundColor: '#5ab047',
        },
        svgStyles: {
          //fill: '#fff',
        }
      },
      vmButtonStyles: {
        buttonStyles: {
          //backgroundColor: '#fff',
          //border: 'none',
        },
        svgStyles: {
          //fill: '#000',
        }
      },
      badge : {
        badgeOptions: {
          //background: 'purple'
        }
      },
      callHistoryButtonStyles: {
        buttonStyles: {
          //backgroundColor: '#fff',
          //border: 'none',
        }
      },
      hangupButtonStyles: {
        buttonStyles: {
          backgroundColor: colorGrid.red8,
          border: 'none',
          borderRadius: '2px'
        },
        labelStyles: {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.red6
        }
      },
      cancelButtonStyles: {
        buttonStyles: {
          //backgroundColor: '#fff',
          //border: 'solid 1px #dedede',
        },
        labelStyles: {
          //color: '#000',
        }
      },

      blindTransferButtonStyles: {
        buttonStyles : {
          border: 'none',
          backgroundColor: colorGrid.red8,
          borderRadius: '2px'
        },
        labelStyles : {
          color: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.red6
        }
      },

      attendedTransferButtonStyles: {
        buttonStyles : {
          backgroundColor: colorGrid.green8,
          borderRadius: '2px'
        },
        svgStyles : {
          fill: colorGrid.gray0
        },
        hoverButtonStyles: {
          backgroundColor: colorGrid.green6
        }
      },

      cancelTransferButtonStyles: {
        buttonStyles: {
          //backgroundColor: '#fff',
          //border: 'solid 1px #dedede',
        },
        labelStyles: {
          //color: '#000',
        }
      },

      dtmfHeaderStyles: {
        //backgroundColor: '#0b4e85',
        //color: '#fff',
      }
    },

    /******** UPDATE **********/
    update: {
      windowStyle:{},
      updateComp:{
        buttonStyles: {},
       labelStyles: {}
      },
      buttonBarComp : {
        buttonBar: {}
      },
      postponeComp: {
        buttonStyles: {},
        labelStyles: {}
      },
      header: {},
      msgArea:{}
    }
  }
};
export default themes;



// WEBPACK FOOTER //
// ./src/themes/theme-styles.js